window.__lc = window.__lc || {};
window.__lc.license = 12834777;
const getOS = _theme.getOS();

_theme.toggleLoading = function (show) {
  if (show) {
    $('.loading-modal').removeClass('hidden');
  } else {
    $('.loading-modal').addClass('hidden');
  }
};
_theme.qvVariants = function () {
  const toggleBtn = document.querySelector('.toggle-btn');
  const descContainer = document.querySelector('.qv-span-prod-desc');

  toggleBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
    toggleBtn.setAttribute('aria-expanded', !isExpanded);
    descContainer.classList.toggle('expanded');
    toggleBtn.textContent = isExpanded ? 'Read More' : 'Read Less';
  });
  document.querySelectorAll('.select-variant').forEach((input) => {
    input.addEventListener('change', (event) => {
      const setSizeValue = document.querySelector('.sidecart-qv .current-selected');
      const setPrice = document.querySelector('.sidecart-qv .sidecart-qv-price span[data-text]');
      const setComparePrice = document.querySelector(
        '.sidecart-qv .sidecart-qv-compare-price span[data-text]'
      );
      const setDiffPrice = document.querySelector(
        '.sidecart-qv .sidecart-qv-per-off span[data-text]'
      );
      const quantitySelect = document.querySelector('.sidecart-qv select.quantity__select');
      const variantImgId = parseInt(event.target.getAttribute('data-image-id'));
      const imgIndex = parseInt(
        event.target
          .closest('.sidecart-qv-inner')
          .querySelector('.sidecart-qv-images li[data-image-id="' + variantImgId + '"]')
          ?.getAttribute('data-slick-index')
      );

      if (imgIndex != null && imgIndex != undefined && !isNaN(imgIndex)) {
        $(event.target)
          .closest('.sidecart-qv-inner')
          .find('.slick-slider')
          .slick('slickGoTo', imgIndex);
      }

      // Sync the hidden swatch inputs if they exist
      const swatchInputs = document.querySelectorAll('.sidecart-qv .sidecart-qv-options input[type="radio"]');
      if (swatchInputs.length > 0) {
        swatchInputs.forEach((swatchInput) => {
          if (swatchInput.value === event.target.value) {
            swatchInput.checked = true;
            swatchInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      // Get all notify me buttons and add to cart buttons
      const allButtons = document.querySelectorAll('.sidecart-qv button[offer-var-id]');
      const allAddToCartBtns = document.querySelectorAll('.sidecart-qv .cta-atc.offer-cta-atc');
      const allNotifyMeBtns = document.querySelectorAll('.sidecart-qv .notify-btn');
      const offerQuickviewWrapper = document.querySelector(
        '.offer-sidecart-qv.active .sidecart-coll-cta'
      );

      const closestSoldOut = event.target.closest('.product-sold-out');

      if (closestSoldOut == null || closestSoldOut == undefined) {
        const isSoldOut = event.target.classList.contains('v-soldout');
        allButtons.forEach((btn) => {
          btn.disabled = isSoldOut;
          btn.innerHTML = isSoldOut ? 'Sold Out' : 'Add to Cart';
          btn.setAttribute('offer-var-id', parseInt(event.target.getAttribute('data-var-id')));
        });
        if (offerQuickviewWrapper) {
          if (isSoldOut) {
            offerQuickviewWrapper.classList.add('disabled_qty');
          } else {
            offerQuickviewWrapper.classList.remove('disabled_qty');
          }
        }
        allAddToCartBtns.forEach((btn) => {
          btn.style.display = isSoldOut ? 'none' : 'flex';
        });
        allNotifyMeBtns.forEach((btn) => {
          btn.style.display = isSoldOut ? 'block' : 'none';
        });
      } else {
        allButtons.forEach((btn) => {
          btn.setAttribute('offer-var-id', parseInt(event.target.getAttribute('data-var-id')));
        });
      }

      if (setSizeValue) setSizeValue.innerHTML = event.target.value;
      if (setPrice) setPrice.innerHTML = event.target.getAttribute('data-price');
      if (setComparePrice) setComparePrice.innerHTML = event.target.getAttribute('data-compare-price');
      if (setDiffPrice) setDiffPrice.innerHTML = event.target.getAttribute('data-price-difference');

      if (quantitySelect) {
        const availableQuantity = parseInt(event.target.getAttribute('data-var-qty')) || 0;

        while (quantitySelect.firstChild) {
          quantitySelect.removeChild(quantitySelect.firstChild);
        }

        if (availableQuantity === 0) {
          const option = document.createElement('option');
          option.value = 1;
          option.textContent = 1;
          quantitySelect.appendChild(option);
          quantitySelect.disabled = true;
        } else {
          quantitySelect.disabled = false;
          for (let i = 1; i <= 10; i++) {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = i;
            if (i > availableQuantity) {
              option.disabled = true;
            }
            quantitySelect.appendChild(option);
          }
        }
      }

    });
  });
};
_theme.toggleSideCart = function (show, callback, isAutoAction) {
  if (show) {
    if (window.enable_gwp_reset_fix !== false) {
      const gwpTrigger = document.querySelector('[data-gwp-trigger]');
      if (gwpTrigger) {
        gwpTrigger.setAttribute('aria-expanded', 'true');
        const gwpModal = document.querySelector('[data-gwp-modal]');
        if (gwpModal) {
          gwpModal.setAttribute('aria-hidden', 'false');
          gwpModal.style.display = 'block';
        }
      }
    }
    const alreadyOpen = $('html').hasClass('cart-show');
    $('html').addClass('cart-show');
    $('.wrapper-overlay').addClass('active');
    $('#dropdown-cart [data-tabindex-toggle]').attr('tabindex', 0);
    // $('[data-minicart-toggle-role-heading]').attr({ role: 'heading', 'aria-level': '2', });
    $('[data-minicart-toggle-role-heading]').each(function () {
      const count = $(this).find('.cart_count').text().trim();
      $(this).attr({
        role: 'heading',
        'aria-level': '2',
        'aria-label': 'Cart(' + count + ')',
      });
    });

    if (!alreadyOpen) {
      $('#dropdown-cart .cart-recommended-products .new-products-grid').slick('refresh');
      setTimeout(function () {
        const cartRecCards = document.querySelectorAll('#dropdown-cart .cart-recommended-products .product-card');
        if (cartRecCards.length) {
          cartRecCards.forEach(function (card) {
            card.style.minHeight = '';
          });
          let maxCardHeight = 0;
          cartRecCards.forEach(function (card) {
            maxCardHeight = Math.max(maxCardHeight, card.getBoundingClientRect().height);
          });
          if (maxCardHeight > 0) {
            const equalHeight = Math.ceil(maxCardHeight) + 'px';
            cartRecCards.forEach(function (card) {
              card.style.minHeight = equalHeight;
            });
          }
        }
        if (typeof _theme.applyCartRecA11y === 'function') _theme.applyCartRecA11y();
      }, 100);
    }
    $('#dropdown-cart .exit.close-cart').attr('aria-label', 'Your cart modal, Close modal');
    if ($('body').hasClass('quickViewModal')) $('body').removeClass('quickViewModal');

    // track action: Datalayer
    _theme.track.trackEvent(
      'minicart_opened',
      isAutoAction ? 'add to cart click' : 'cart icon click'
    );

    if (_theme.MiniCart?.prepareOnOpen) {
      _theme.MiniCart.prepareOnOpen();
    }

    if (!alreadyOpen) {
      // Trap focus inside modal whenever it open
      _theme.focusTrap(
        $('#dropdown-cart'),
        function () {
          _theme.toggleSideCart(false, null, false);
          if (callback && typeof callback === 'function') callback();
        },
        null,
        null,
        null,
        isAutoAction
      );

      if (isAutoAction) {
        setTimeout(function () {
          $('#dropdown-cart')
            .parent()
            .siblings()
            .not('#minicart-sr-only')
            .attr('aria-hidden', 'true');
          $('#dropdown-cart .exit.close-cart').focus();
        }, 3500);
      } else {
        $('#dropdown-cart')
          .parent()
          .siblings()
          .not('#minicart-sr-only')
          .attr('aria-hidden', 'true');
      }
    } else if (isAutoAction) {
      setTimeout(function () {
        $('#dropdown-cart')
          .parent()
          .siblings()
          .not('#minicart-sr-only')
          .attr('aria-hidden', 'true');
        $('#dropdown-cart .exit.close-cart').focus();
      }, 3500);
    }
  } else {
    $('#dropdown-cart').parent().siblings().removeAttr('aria-hidden');
    if (_theme.isMobile) {
      $('cart-offer-list').attr('aria-hidden', 'true');
    }
    $('html').removeClass('cart-show');
    _theme.toggleSideCartQv();
    $('.wrapper-overlay').removeClass('active');
    $('#dropdown-cart, #dropdown-cart [data-tabindex-toggle]').attr('tabindex', -1);
    $('[data-minicart-toggle-role-heading]').removeAttr('aria-level role');

    // track action: Datalayer
    _theme.track.trackEvent('minicart_closed', isAutoAction ? 'outside click' : 'cross icon click');

    if (callback && typeof callback === 'function') callback();
    else $('header.site-header [data-cart-toggle]').focus();
  }
};

_theme.toggleSideCartQv = function (show) {
  if (show) {
    setTimeout(() => {
      const id = $('.sidecart-qv.active .product-form__input :radio:checked').attr('data-image-id');
      const imgIndex = parseInt(
        $(
          '.sidecart-qv.active .sidecart-qv-inner .sidecart-qv-images li[data-image-id="' +
            id +
            '"]'
        )?.attr('data-slick-index')
      );
      if (imgIndex != null && imgIndex != undefined && !isNaN(imgIndex)) {
        $('.sidecart-qv.active .slick-slider').slick('slickGoTo', imgIndex);
      }
    }, 600);
    document.querySelector('cart-offer-list').classList.add('product_active');
    $('.sidecart-qv').removeAttr('aria-hidden');
    $('.sidecart-qv .sidecart-qv-close').attr('tabindex', '0');
    if (_theme.isMobile) {
      $('#dropdown-cart').parent().attr('aria-hidden', 'true');
    }
    $('.wrapper-overlay').addClass('active');
    $('[data-sidecard-qv-heading]')
      .attr({ role: 'heading', 'aria-level': '2' })
      .removeAttr('aria-hidden');
    $('.sidecart-qv').addClass('active');
    // $('*').not($('.sidecart-qv').find('*')).not('.sidecart-qv').not($('.sidecart-qv').parents()).attr('aria-hidden','true');
  } else {
    $('.wrapper-overlay').removeClass('active');
    document.querySelector('cart-offer-list').classList.remove('product_active');
    if (_theme.isMobile) {
      $('#dropdown-cart').parent().removeAttr('aria-hidden');
    }

    $('[data-sidecard-qv-heading]').removeAttr('role aria-level');
    $('.sidecart-qv').removeClass('active').attr('aria-hidden', 'true');
    $('.sidecart-qv .sidecart-qv-close').attr('tabindex', '-1');
  }
};

_theme.initSlideShow = function () {
  if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;
  if (_theme._slideShowInitialized) return;

  _theme._slideShowInitialized = true;

  if ($('[data-init-slideshow]').length) {
    const $slickElement = $('[data-init-slideshow]');
    const $status = $('.pagingInfo');
    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      const i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
      setTimeout(function () {
        $('[data-init-slideshow] .item').attr('tabindex', '-1');
      }, 1000);
    });
    $('[data-init-slideshow]').slick({
      infinite: true,
      autoplay: true,
      pauseOnDotsHover: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
    });
  }
  $('[data-init-slideshow]').on('touchstart', (e) => {
    $('[data-init-slideshow]').slick('slickPlay');
  });
  $('.slide-Play-Pause').on('click', function (e) {
    const targetedEl = $(this);
    targetedEl.toggleClass('pause-slider');
    if (targetedEl.hasClass('pause-slider')) {
      $('[data-init-slideshow]').slick('slickPause');
      $('.slide-Play-Pause').attr('aria-label', 'Banner Image slider play button');
    } else {
      $('[data-init-slideshow]').slick('slickPlay');
      $('.slide-Play-Pause').attr('aria-label', 'Banner Image slider pause button');
    }
  });
  //$(window).width()>767 &&
  if ($('.brand-slider-items').length) {
    // const $toggleSliderBtn = $('[data-brands-slider-toggle]');
    const sliderSettings = {
      rows: 0,
      dots: false,
      arrows: true,
      infinite: false,
      autoplaySpeed: 1000,
      slidesToScroll: 6,
      slidesToShow: 6,
      mobileFirst: true,
      responsive: [
        { breakpoint: 1500, settings: { slidesToShow: 6, slidesToScroll: 6 } },
        { breakpoint: 1300, settings: { slidesToShow: 5, slidesToScroll: 5 } },
        { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 4 } },
        { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 320, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 1, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    };

    initBrandSlider(false);

    function initBrandSlider(autoplay) {
      if (autoplay) {
        sliderSettings.autoplay = autoplay;
        sliderSettings.autoplaySpeed = 1000;
        sliderSettings.speed = 2000;
      }
      if ($('.brand-slider-items').hasClass('slick-initialized')) {
        $('.brand-slider-items').slick('unslick');
      }
      // $('.brand-slider-items').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      //   $('.brand-slider-items .slick-slide').removeAttr('tabindex');
      // });
      $('.brand-slider-items').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
        slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
        const perPage = window.innerWidth < 768 ? 2 : 6;
        const colIndex = Math.ceil(currentSlide / perPage);
        _theme.track.trackView('Brands slider', colIndex);
      });
      $('.brand-slider-items').on('init', function (event, slick, currentSlide, nextSlide) {
        slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
        slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
      });
      $('.brand-slider-items').slick(sliderSettings);
      // $('#brands-slider-status').text('brands carousel is ' + (autoplay ? 'running' : 'paused'));
      // let btnText = autoplay ? 'pause carousel' : 'play carousel';
      // $toggleSliderBtn.text(btnText).attr('aria-label', btnText);
      // isAutoplay = autoplay;
    }
  }

  if ($(window).width() > 767) {
    $('img.slide-mobile').remove();
  } else {
    $('img.slide-pc').remove();
  }

  if ($(window).width() < 769) {
    _theme.initSlickSlider($('.top-seller-slider'), {
      dots: false,
      infinite: true,
      speed: 700,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:
        '<button tabindex="-1" type="button" aria-label="previous" class="slick-arrow slick-prev" style="display: flex;"><img width="19" height="19" loading="lazy" sizes="24px" src="https://cdn.shopify.com/s/files/1/0269/7763/2389/files/white_arrow.svg?v=1676481199" alt="Previous Arrow" style="cursor:pointer;"><span class="screen-reader-only">Previous</span></button>',
      nextArrow:
        '<button type="button" aria-label="next" class="slick-arrow slick-next" style="display: flex;"><img width="19" height="19" loading="lazy" sizes="24px" src="https://cdn.shopify.com/s/files/1/0269/7763/2389/files/white_arrow.svg?v=1676481199" alt="Next Arrow" style="cursor:pointer;"><span class="screen-reader-only">Next</span></button>',
    });
  }

  _theme.applyCartRecA11y = function () {
    const $s = $('#section-cart-recommendation .new-products-grid');
    if (!$s.length) return;

    const $prevArrow = $s.find('.slick-prev');
    if ($prevArrow.hasClass('slick-disabled')) {
      $prevArrow.attr({ 'aria-hidden': 'true', tabindex: '-1' });
    } else {
      $prevArrow.removeAttr('aria-hidden tabindex');
    }

    const $nextArrow = $s.find('.slick-next');
    if ($nextArrow.hasClass('slick-disabled')) {
      $nextArrow.attr({ 'aria-hidden': 'true', tabindex: '-1' });
    } else {
      $nextArrow.removeAttr('aria-hidden tabindex');
    }

    $s.find('.product-top').attr('aria-hidden', 'true');
    $s.find('[role="heading"][aria-level="3"]').attr('aria-hidden', 'true');

    const $focusable = $s
      .find('a, button, input, select, textarea')
      .filter(':visible')
      .not('[tabindex="-1"]');

    // Restore original aria-labels
    $focusable.each(function () {
      const originalLabel = $(this).attr('data-original-aria-label');
      if (originalLabel !== undefined) {
        if (originalLabel === '') {
          $(this).removeAttr('aria-label');
        } else {
          $(this).attr('aria-label', originalLabel);
        }
      }
    });

    // Append " carousel" suffix to the first visible, focusable element
    const $first = $focusable.first();
    if ($first.length) {
      let originalLabel = $first.attr('data-original-aria-label');
      if (originalLabel === undefined) {
        originalLabel = $first.attr('aria-label') || '';
        $first.attr('data-original-aria-label', originalLabel);
      }
      const baseText = originalLabel || $first.text().replace(/\s+/g, ' ').trim();
      const headingText =
        $('#cart-recommendation-heading').text().replace(/\s+/g, ' ').trim() ||
        'Recommended Products';
      $first.attr('aria-label', headingText + ' carousel ' + baseText);
    }
  };

  _theme.initSlickSlider(
    $('#dropdown-cart .cart-recommended-products .new-products-grid'),
    {
      rows: 0,
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" aria-label="Previous slide" class="slick-arrow slick-prev" style="display: flex;"><img width="19" height="19" loading="lazy" sizes="24px" src="https://cdn.shopify.com/s/files/1/0269/7763/2389/files/left-arrow.svg?v=1726055837" alt="" aria-hidden="true" style="cursor:pointer;"><span class="screen-reader-only" aria-hidden="true">Previous</span></button>',
      nextArrow:
        '<button type="button" aria-label="Next slide" class="slick-arrow slick-next" style="display: flex;"><img width="19" height="19" loading="lazy" sizes="24px" src="https://cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481" alt="" aria-hidden="true" style="cursor:pointer;"><span class="screen-reader-only" aria-hidden="true">Next</span></button>',
      infinite: false,
      slidesToShow: 2,
      accessibility: true,
      slidesToScroll: 2,
      mobileFirst: true,
      responsive: [
        { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
        { breakpoint: 320, settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
        { breakpoint: 1, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      ],
    },
    function () {
      setTimeout(_theme.applyCartRecA11y, 0);
    },
    function () {
      setTimeout(_theme.applyCartRecA11y, 0);
    }
  );

  _theme.initSlickSlider($('.chris-brands .chris-brands-wrap'), {
    rows: 0,
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 6,
    accessibility: true,
    slidesToScroll: 6,
    mobileFirst: true,
    responsive: [
      { breakpoint: 1500, settings: { slidesToShow: 5, slidesToScroll: 5 } },
      { breakpoint: 1300, settings: { slidesToShow: 4, slidesToScroll: 4 } },
      { breakpoint: 991, settings: { slidesToShow: 4, slidesToScroll: 4 } },
      { breakpoint: 600, settings: { slidesToShow: 2.5, slidesToScroll: 2 } },
      { breakpoint: 320, settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
      { breakpoint: 1, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  });

  if (window.innerWidth > 767) {
    _theme.initSlickSlider($('.chris-coll-wrap.desk-grid.product-collection'), {
      rows: 0,
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 6,
      accessibility: true,
      slidesToScroll: 6,
      mobileFirst: true,
      responsive: [
        { breakpoint: 1500, settings: { slidesToShow: 5, slidesToScroll: 5 } },
        { breakpoint: 1300, settings: { slidesToShow: 5, slidesToScroll: 5 } },
        { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 600, settings: { slidesToShow: 2.5, slidesToScroll: 2 } },
        { breakpoint: 320, settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
        { breakpoint: 1, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    });
  }

};

const createSliderCallback = function (slick) {
  if (!slick || !slick.$slider) return;
  const FOCUSABLE_SELECTOR =
    'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]';
  slick.$slider.find('.slick-slide').find(FOCUSABLE_SELECTOR).attr('tabindex', '-1');
  slick.$slider.find('.slick-slide.slick-active').find(FOCUSABLE_SELECTOR).attr('tabindex', '0');
};

_theme.initHorizontalScroll = function () {
  if ($('.custom-slider-scrollbar').length === 0) return;
  $('.custom-slider-scrollbar').each(function () {
    const t = $(this);
    const prev = t.find('.previous-slide-btn,.rec-slider-arrow.arrow-left');
    const next = t.find('.next-slide-btn,.rec-slider-arrow.arrow-right');
    const ele = t.find('.custom-slider-scrollbar');
    if (!ele || !ele[0]) return;
    ele.attr('data-width', ele[0].scrollWidth);
    if (ele.scrollLeft() == 0) {
      prev.addClass('disabled');
    }
  });
  $('.custom-slider-scrollbar').on('scroll', function () {
    const t = $(this);
    const ele = t;
    const hasArrowBtns =
      ele.prev().hasClass('previous-slide-btn') || ele.next().hasClass('previous-slide-btn');
    if (!hasArrowBtns) return;
    const totalWidth = ele.scrollLeft() + ele.width();
    const dw = ele.attr('data-width');
    ele.next().removeClass('disabled');
    ele.prev().removeClass('disabled');
    if (ele.scrollLeft() == 0) {
      ele.prev().addClass('disabled');
      ele.prev().attr('tabindex', -1);
    } else {
      ele.prev().attr('tabindex', 0);
    }

    if (totalWidth == dw) {
      ele.next().addClass('disabled');
      ele.next().attr('tabindex', -1);
    } else {
      ele.next().attr('tabindex', 0);
    }
  });
  $('.next-slide-btn,.rec-slider-arrow.arrow-right').on('click', function () {
    const t = $(this);
    const elem = t.parent().find('.custom-slider-scrollbar');
    const w = t.parent().find('.item:first-child').outerWidth() * 3;
    const scrollLeft = elem.scrollLeft();
    const dw = elem.attr('data-width');
    elem.stop().animate({
      scrollLeft: scrollLeft + w,
    });
  });
  $('.previous-slide-btn,.rec-slider-arrow.arrow-left').on('click', function () {
    const t = $(this);
    const elem = t.parent().find('.custom-slider-scrollbar');
    const w = t.parent().find('.item:first-child').outerWidth() * 3;
    const scrollLeft = elem.scrollLeft();
    if (scrollLeft > 0) {
      elem.stop().animate({
        scrollLeft: scrollLeft - w,
      });
    }
  });
  $('.panel-group [data-toggle]').off('click keydown').on('click keydown', handleFaqAccordian);

  jQuery(document).on('click keydown', '.klarna-faq-item button', function (event) {
    if (event.type === 'click' || event.keyCode === 13 || event.keyCode === 32) {
      event.preventDefault();

      const button = jQuery(this);
      const isExpanded = button.attr('aria-expanded') === 'true';
      button.attr('aria-expanded', !isExpanded);
      button.toggleClass('active');

      const content = button.closest('.klarna-faq-item').find('.content');
      content.stop(true, true).slideToggle();

      button
        .closest('.klarna-faq-item')
        .siblings()
        .find('button')
        .attr('aria-expanded', 'false')
        .removeClass('active');
      button.closest('.klarna-faq-item').siblings().find('.content').stop(true, true).slideUp();
    }
  });
  const accordionHeaders = document.querySelectorAll('[data-accordion-header]');

  if (accordionHeaders.length > 0) {
    const firstHeader = accordionHeaders[0].getAttribute('data-category-tabber');
    const matchingPanels = document.querySelectorAll(
      `.panel-group .panel-default[data-category-accordion="${firstHeader}"]`
    );

    matchingPanels.forEach((panel) => {
      panel.classList.add('show-accordion');
      panel.removeAttribute('hidden');
    });
  }

  accordionHeaders.forEach((header, index) => {
    // Add keyboard navigation
    header.addEventListener('keydown', (e) => {
      const tabs = Array.from(accordionHeaders);
      const currentIndex = tabs.indexOf(header);
      let newIndex;

      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          newIndex = currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
          tabs.forEach((tab) => tab.classList.remove('using-keyboard'));
          tabs[newIndex].focus();
          tabs[newIndex].classList.add('using-keyboard');
          break;
        case 'ArrowRight':
          e.preventDefault();
          newIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
          tabs.forEach((tab) => tab.classList.remove('using-keyboard'));
          tabs[newIndex].focus();
          tabs[newIndex].classList.add('using-keyboard');
          break;
        case 'Home':
          e.preventDefault();
          tabs[0].focus();
          break;
        case 'End':
          e.preventDefault();
          tabs[tabs.length - 1].focus();
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          header.click();
          break;
      }
    });

    header.addEventListener('click', (e) => {
      const category = header.getAttribute('data-category-tabber');
      const tabber = e.currentTarget;

      // Update ARIA states
      accordionHeaders.forEach((h) => {
        h.classList.remove('active-tabber');
        h.setAttribute('aria-selected', 'false');
        h.setAttribute('tabindex', '-1');
      });

      tabber.classList.add('active-tabber');
      tabber.setAttribute('aria-selected', 'true');
      tabber.setAttribute('tabindex', '0');

      // Show/hide corresponding panels
      document.querySelectorAll('.panel-group .panel-default').forEach((panel) => {
        const panelCategory = panel.getAttribute('data-category-accordion');

        if (panelCategory === category) {
          panel.classList.add('show-accordion');
          panel.removeAttribute('hidden');
        } else {
          panel.classList.remove('show-accordion');
          panel.setAttribute('hidden', '');
        }
      });

      // Announce tab change to screen readers
      const announcement = document.createElement('div');
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.className = 'sr-only';
      announcement.textContent = `Switched to ${category} tab`;
      document.body.appendChild(announcement);

      setTimeout(() => {
        document.body.removeChild(announcement);
      }, 1000);
    });
  });

  function handleFaqAccordian(evt) {
    let run = false;
    if (evt.type && evt.type === 'click') {
      if (evt.pointerId !== -1) run = true;
      if (evt.originalEvent && evt.originalEvent.pointerId !== -1) run = true;
    }
    if ((evt.keyCode && evt.keyCode === 13) || evt.keyCode === 32) run = true;
    if (!run) return;
    evt.preventDefault();
    const expand = JSON.parse($(this).attr('aria-expanded'));
    $(this).attr('aria-expanded', !expand);
    $(this).closest('.panel').find('.panel-collapse').stop().slideToggle();
    $(this).closest('.panel').find('.panel-title').toggleClass('rotateArrow');
  }
};

_theme.setMinicartHeight = function () {
  if (getOS === 'ios') {
    $('.cart-bottom-footer').addClass('heightAdjust');
  }
};

_theme.initHeaderEvetns = function () {
  $('header .hamburger-icon .icon-nav').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('[data-menu-navigation]').removeClass('hidden');
    $('[data-menu-close]').addClass('hidden');
    $('[data-menu-open]').removeClass('hidden');
    $('.wrapper-overlay').addClass('active');
    $('html').toggleClass('translate-overlay');
    const aria = $('.hamburger-icon .icon-nav').attr('aria-expanded');
    if (aria == 'true') {
      $('.hamburger-icon .icon-nav').attr('aria-expanded', 'false');
    } else {
      $('.hamburger-icon .icon-nav').attr('aria-expanded', 'true');
    }

    $('.close-menu-mb').toggleClass('menu-open');
    $('.main-menu.jas-mb-style').css({ overflow: '' });
    $('body').css({ overflow: 'hidden' });
    $('.site-nav')
      .find('[data-toggle-menu-mb]')
      .parent()
      .next('.sub-menu-mobile')
      .removeClass('sub-menu-open');

    setTimeout(function () {
      _theme.focusTrap(
        $('.mb-area-mob nav.nav-bar'),
        function () {
          $('.mb-area-mob button.close-mob-trig').click();
        },
        null,
        false,
        false,
        true
      );
    }, 250);

    if (_theme.isMobile) {
      $('.mb-area-mob')
        .closest('#shopify-section-navigation')
        .siblings()
        .attr({ 'aria-hidden': 'true' });
    }

    // setTimeout(function(){
    //   $('.mb-area-mob .site-nav .menu-lv-1').first().find('a.menu__moblie').focus();
    // }, 100);
  });

  $('footer .hamburger-menu-icon button').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    this.setAttribute('aria-expanded', !JSON.parse(this.getAttribute('aria-expanded')));

    if (
      !$('[data-menu-navigation]').hasClass('hidden') &&
      $('[data-offers-navigation]').hasClass('hidden')
    ) {
      $('.mb-area-mob button.close-mob-trig').click();
    } else {
      if (!$('[data-offers-navigation]').hasClass('hidden')) {
        $('[data-offers-navigation]').addClass('hidden');
        $('[data-menu-navigation]').removeClass('hidden');
        $('[data-menu-close]').addClass('hidden');
        $('[data-menu-open]').removeClass('hidden');
        $('[data-offer-close]').removeClass('hidden');
        $('[data-offer-open]').addClass('hidden');
      } else {
        $('[data-offers-navigation]').addClass('hidden');
        $('[data-menu-navigation]').removeClass('hidden');
        $('[data-menu-close]').addClass('hidden');
        $('[data-menu-open]').removeClass('hidden');
        _theme.toggleCustomerForm();

        const url = window.location.pathname;
        if (url.indexOf('store-locator') < 0) {
          $('.wrapper-overlay').addClass('active');
        }
        $('html').toggleClass('translate-overlay');

        $('.close-menu-mb').toggleClass('menu-open');
        $('.main-menu.jas-mb-style').css({ overflow: '' });
        $('body').css({ overflow: 'hidden' });
        $('.site-nav')
          .find('[data-toggle-menu-mb]')
          .parent()
          .next('.sub-menu-mobile')
          .removeClass('sub-menu-open');

        const offerNavigationModal = document.querySelector('nav[data-offers-navigation]');
        const menuNavigationModal = document.querySelector('nav[data-menu-navigation]');

        if (_theme.isMobile) {
          $('.mb-area-mob')
            .closest('#shopify-section-navigation')
            .siblings()
            .attr({ 'aria-hidden': 'true' });
          if (offerNavigationModal) offerNavigationModal.setAttribute('aria-hidden', true);
          if (menuNavigationModal) menuNavigationModal.setAttribute('aria-hidden', false);
        }

        setTimeout(function () {
          _theme.focusTrap(
            $('.mb-area-mob nav.nav-bar'),
            function () {
              $('.mb-area-mob button.close-mob-trig').click();
              if (offerNavigationModal) offerNavigationModal.removeAttribute('aria-hidden');
            },
            null,
            false,
            false,
            true
          );
        }, 250);
      }
    }
  });

  $('footer .offers-menu-icon button').click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    this.setAttribute('aria-expanded', !JSON.parse(this.getAttribute('aria-expanded')));

    if (
      !$('[data-offers-navigation]').hasClass('hidden') &&
      $('[data-menu-navigation]').hasClass('hidden')
    ) {
      $('.mb-area-mob button.close-mob-trig').click();
    } else {
      if (!$('[data-menu-navigation]').hasClass('hidden')) {
        $('[data-menu-navigation]').addClass('hidden');
        $('[data-offers-navigation]').removeClass('hidden');
        $('[data-offer-close]').addClass('hidden');
        $('[data-offer-open]').removeClass('hidden');
        $('[data-menu-close]').removeClass('hidden');
        $('[data-menu-open]').addClass('hidden');
      } else {
        $('[data-menu-navigation]').addClass('hidden');
        $('[data-offers-navigation]').removeClass('hidden');
        $('[data-offer-close]').addClass('hidden');
        $('[data-offer-open]').removeClass('hidden');
        _theme.toggleCustomerForm();

        const url = window.location.pathname;
        if (url.indexOf('store-locator') < 0) {
          $('.wrapper-overlay').addClass('active');
        }
        $('html').toggleClass('translate-overlay');

        $('.close-menu-mb').toggleClass('menu-open');
        $('.main-menu.jas-mb-style').css({ overflow: '' });
        $('body').css({ overflow: 'hidden' });
        $('.site-nav')
          .find('[data-toggle-menu-mb]')
          .parent()
          .next('.sub-menu-mobile')
          .removeClass('sub-menu-open');

        const offerNavigationModal = document.querySelector('nav[data-offers-navigation]');
        const menuNavigationModal = document.querySelector('nav[data-menu-navigation]');
        if (_theme.isMobile) {
          $('.mb-area-mob')
            .closest('#shopify-section-navigation')
            .siblings()
            .attr({ 'aria-hidden': 'true' });
          if (offerNavigationModal) offerNavigationModal.setAttribute('aria-hidden', false);
          if (menuNavigationModal) menuNavigationModal.setAttribute('aria-hidden', true);
        }

        setTimeout(function () {
          _theme.focusTrap(
            $('.mb-area-mob nav.nav-bar'),
            function () {
              $('.mb-area-mob button.close-mob-trig').click();
              if (menuNavigationModal) menuNavigationModal.removeAttribute('aria-hidden');
            },
            null,
            false,
            false,
            true
          );
        }, 250);
      }
    }
  });

  $(document).on('click', '.wrapper-overlay,.mb-area-mob .close-mob-trig', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const isCloseButton = e.currentTarget && e.currentTarget.classList.contains('close-mob-trig');
    $('.mb-area-mob .sub-menu-mobile').removeClass('sub-menu-open');
    $('html').removeClass('translate-overlay');
    $('.toolbar .column-left .sidebar-label span').attr('aria-expanded', 'false');
    $('.close-menu-mb').removeClass('menu-open');
    $('.main-menu.jas-mb-style').css({ overflow: '' });
    $('body').css({ overflow: '' });
    $('.site-nav')
      .find('[data-toggle-menu-mb]')
      .parent()
      .next('.sub-menu-mobile')
      .removeClass('sub-menu-open');
    $('.wrapper-overlay').removeClass('active');
    $('.hamburger-icon .icon-nav').attr('aria-expanded', 'false');
    $('.close-menu-mb').removeClass('menu-open');
    $('[data-menu-navigation]').addClass('hidden');
    $('[data-offers-navigation]').addClass('hidden');
    $('[data-menu-close]').removeClass('hidden');
    $('[data-menu-open]').addClass('hidden');
    $('[data-offer-close]').removeClass('hidden');
    $('[data-offer-open]').addClass('hidden');
    $('.transcript-modal').removeClass('active');
    $('body').removeClass('transcript-modal-open');
    $('body').removeClass('quick-view-open');

    window.currentQuickViewGridIndex = null; // Clear stored grid index when mobile quickview is closed

    const footerIconSelectors = [
      '.footer-pane-item.hamburger-menu-icon',
      '.footer-pane-item.offers-menu-icon',
    ];
    footerIconSelectors.forEach((selector) => {
      const elems = document.querySelectorAll(selector);
      elems.forEach((elem) => elem.setAttribute('aria-expanded', false));
    });

    _theme.toggleSideCart(false, null, !isCloseButton);

    if (_theme.isMobile) {
      $('.mb-area-mob').closest('#shopify-section-navigation').siblings().removeAttr('aria-hidden');
      ['nav[data-offers-navigation]', 'nav[data-menu-navigation]'].forEach((selector) => {
        const elem = document.querySelector(selector);
        if (elem) elem.removeAttribute('aria-hidden');
      });
    }
    if (_theme.isMobile) {
      setTimeout(function () {
        $('footer .hamburger-menu-icon').focus();
      }, 250);
    } else {
      setTimeout(function () {
        $('header .hamburger-icon .icon-nav').focus();
      }, 250);
    }
  });

  $(document).on('click', '[data-toggle-menu-mb]', handleSubmenuTrigger);
  $(document).on('click', '.menu-img-item', handleSubmenuTrigger);
  $(document)
    .off('click', '.sub-menu-mobile .cm-mega-menu-alpha-cd')
    .on('click', '.sub-menu-mobile .cm-mega-menu-alpha-cd', handleHeaderBrandLetterClick);
  $(document)
    .off('keydown', '.sub-menu-mobile .cm-mega-menu-alpha-cd')
    .on('keydown', '.sub-menu-mobile .cm-mega-menu-alpha-cd', handleHeaderBrandLetterClick);
  $(document)
    .off('click', '.cm-mega-menu-filter-title strong')
    .on('click', '.cm-mega-menu-filter-title', handleHeaderAllBrands);
  $(document)
    .off('keydown', '.cm-mega-menu-filter-title strong')
    .on('keydown', '.cm-mega-menu-filter-title', handleHeaderAllBrands);

  if ($(window).width() > 1199) {
    $('.site-nav .no-mega-menu .sub-menu-mobile').remove();
  }

  $('.site-nav-dropdown a span').each(function () {
    const txt = $(this).text();
    const clas = txt.toLowerCase().replaceAll(' ', '_');
    $(this).parent('a').addClass(clas);
  });

  function handleSubmenuTrigger(evt) {
    evt.preventDefault();
    // evt.stopPropagation();
    // evt.stopImmediatePropagation();
    if ($(window).width() > 1025) {
      handleDesktopMegaMenu.call(this, evt);
    } else {
      handleMobileMegaMenu.call(this, evt);
    }
  }

  function handleDesktopMegaMenu(evt) {
    const $self = $(this);
    const $parent = $(this).closest('li.menu-lv-1');
    $parent.toggleClass('active').siblings('li').removeClass('active');
    const attr = $(this).attr('aria-expanded') || false;
    const $submenu = $self.next('.sub-menu-mobile');
    $(this).attr('aria-expanded', !JSON.parse(attr));

    setTimeout(() => {
      // _theme.focusTrap($submenu, function(){
      //   $parent.removeClass('active');
      //   $self.focus();
      //   $self.attr('aria-expanded', false);
      // });

      $submenu.off('keydown').on('keydown', function (evt) {
        if (evt.key === 'Escape') {
          $parent.removeClass('active');
          $self.focus();
          $self.attr('aria-expanded', false);
        }
      });

      $submenu.off('focusout').on('focusout', function (evt) {
        if (evt.relatedTarget && !$submenu[0].contains(evt.relatedTarget)) {
          $parent.removeClass('active');
          $self.attr('aria-expanded', false);
        }
      });
    }, 250);
  }

  function handleMobileMegaMenu(evt) {
    const $self = $(this);
    let expand = $(this).attr('aria-expanded') || false;
    expand = JSON.parse(expand);
    $(this).attr('aria-expanded', !expand);
    let $menu = $(this).next('.sub-menu-mobile');
    if ($menu.length === 0) $menu = $(this).parent().find('.sub-menu-mobile').first();
    const isOpen = $menu.hasClass('sub-menu-open');
    if (isOpen) {
      $menu.removeClass('sub-menu-open');
      $('.mb-area-mob').css({ 'overflow-y': 'auto' });
      $menu.attr('aria-hidden', 'true');
      $('*')
        .not($('.sub-menu-open').find('*'))
        .not('.sub-menu-open')
        .not($('.sub-menu-open').parents())
        .attr('aria-hidden', 'false');
    } else {
      $menu.addClass('sub-menu-open').css({ overflow: '' });
      $('*')
        .not($('.sub-menu-open').find('*'))
        .not('.sub-menu-open')
        .not($('.sub-menu-open').parents())
        .attr('aria-hidden', 'true');
      $('.mb-area-mob').css({ overflow: 'hidden' });
      $menu.attr('aria-hidden', 'false');
    }

    $(this).animate({ scrollTop: 0 }, 0);
    $(this).css({ overflow: 'hidden' });

    if (_theme.isMobile) {
      $self.closest('.menu-lv-1').siblings().attr('aria-hidden', 'true');
      $self.closest('.sub-menu-mobile').find('.menu-col-banner').attr('aria-hidden', 'true');
      $self.closest('[data-griditem]').siblings().attr('aria-hidden', 'true');
    }

    setTimeout(function () {
      _theme.focusTrap(
        $menu,
        function () {
          $menu.removeClass('sub-menu-open');
          $self.attr('aria-expanded', false);
          $self.focus();
        },
        null,
        false,
        false,
        true
      );
    }, 250);
  }

  function handleHeaderAllBrands(evt) {
    let run = false;
    if (evt.type && evt.type === 'click') {
      if (evt.pointerId !== -1) run = true;
      if (evt.originalEvent && evt.originalEvent.pointerId !== -1) run = true;
    }
    if ((evt.keyCode && evt.keyCode === 13) || evt.keyCode === 32) run = true;
    if (!run) return;
    // $('#header-brands-load-status').text('');
    $('.cm-mega-menu-alpha-cd').removeClass('active');
    $('.cm-mega-menu-filter-content li').removeClass('show-filter-li');
    $('.featured-brands-btm-btn').addClass('active');
    // $('#header-brands-load-status').text('brands are loaded in brands region');
    $('.cm-mega-menu-filter-content').removeClass('show-area');
    $('.cm-mega-menu-tp-1-menu').addClass('show-area').find('a').first().focus();
  }

  function handleHeaderBrandLetterClick(evt) {
    let run = false;
    if (evt.type && evt.type === 'click') {
      if (evt.pointerId !== -1) run = true;
      if (evt.originalEvent && evt.originalEvent.pointerId !== -1) run = true;
    }
    if ((evt.keyCode && evt.keyCode === 13) || evt.keyCode === 32) run = true;
    if (!run) return;
    // $('#header-brands-load-status').text('');
    $(this)
      .addClass('active')
      .attr('aria-selected', true)
      .siblings()
      .removeClass('active')
      .attr('aria-selected', false);
    let letter = $(this).data('letter');
    if (!letter) return;
    letter = letter.toLowerCase().trim();
    const arrletter = letter;
    $('span.go-back-ttl-a-z-t').text(arrletter);
    let list = '';
    _theme.vendors.map(function (brand) {
      const first_letter = brand.substr(0, 1).toLowerCase().trim();
      if (letter === first_letter) {
        list +=
          '<li class="show-filter-li"><a aria-label="' +
          brand +
          '" href="/collections/' +
          _theme.Helpers.handleize(brand) +
          '">' +
          brand +
          '</a></li>';
      }
    });
    $('[data-header-brands-list]').empty().html(list);
    // $('#header-brands-load-status').text('brands are loaded in brands region');
    $('.cm-mega-menu-tp-1-menu').removeClass('show-area');
    $('.cm-mega-menu-filter-content').addClass('show-area');
    $('.featured-brands-btm-btn').removeClass('active');
    $('.cm-mega-menu-filter-content [data-header-brands-list] li:first-child a').focus();
  }
};

_theme.initTrackOrderPage = function () {
  if ($('#tracktorOrderForm').length === 0) return;
  $('#tracktorOrderForm input').on('invalid', function (evt) {
    const msg =
      evt.target.name === 'userEmail'
        ? 'Please fill order email field'
        : 'Please fill order number field';
    this.setCustomValidity(msg);
  });

  $('#tracktorOrderForm input').on('change', function (evt) {
    try {
      this.setCustomValidity('');
    } catch (e) {}
  });
};

_theme.initNavigationEvents = function () {
  $(
    'body .mb-area-mob .site-nav .menu-mb-title .close-mob-trig, body .mb-area-mob .site-nav .mega-menu .menu-lv-2 .menu-mb-title .close-mob-trig'
  ).remove();
  $(
    'body .mb-area-mob .site-nav .menu-mb-title, body .mb-area-mob .site-nav .mega-menu .menu-lv-2 .menu-mb-title'
  ).append(
    '<button type="button" class="close-mob-trig" aria-label="Close"><img width="15" height="15" loading="lazy" src="//perfumania.com/cdn/shop/files/icon-img-close.svg?v=7811153589835620510" alt="Close"></button>'
  );

  $('body .mb-area-mob .site-nav .menu-mb-title .icon-dropdown').click(function (e) {
    const isNestedMenu = $(this).parents('.sub-menu-mobile').length > 1 ? true : false;
    const $submenu = $(this).closest('.sub-menu-mobile');
    $submenu.removeClass('sub-menu-open');
    $('*')
      .not($('.sub-menu-open').find('*'))
      .not('.sub-menu-open')
      .not($('.sub-menu-open').parents())
      .not(' button')
      .attr('aria-hidden', 'false');
    $submenu.parent().find('.icon-dropdown').first().focus();
    $submenu.attr('aria-hidden', 'true');
    $('.mb-area-mob').css({ overflow: 'scroll' });

    if (_theme.isMobile) {
      if ($submenu.parent().hasClass('menu-lv-1')) {
        $submenu.parent().siblings().removeAttr('aria-hidden');
      }
      $submenu
        .parent()
        .closest('.sub-menu-mobile')
        .find('.menu-col-banner')
        .removeAttr('aria-hidden');
      $submenu
        .parent()
        .closest('.sub-menu-mobile')
        .find('[data-griditem]')
        .siblings()
        .removeAttr('aria-hidden');
    } else $('.mb-area-mob').removeAttr('style');
    e.stopPropagation();
  });
  $('.mb-area-mob .site-nav .menu-mb-title .icon-dropdown')
    .off('keydown')
    .on('keydown', function (evt) {
      if (evt.which === 13 || evt.which === 32) {
        evt.preventDefault();
        evt.target.click();
      }
    });

  $('span.go-back-ttl, button.go-back-ttl').click(function (e) {
    $(this).parent().parent('.cm-mega-menu-dl-back').removeClass('sub-menu-open');
    e.stopPropagation();
  });
  $('button.a-z-back-btn').click(function (e) {
    $(this).parent().parent('.cm-mega-menu-filter-menu').removeClass('sub-menu-open');
    $(this).closest('.sub-menu-mobile').find('*').removeAttr('aria-hidden');
    e.stopPropagation();
  });
  $('span.back-btn-a-z').click(function (e) {
    $(this).parent().parent('.cm-mega-menu-filter-content').removeClass('show-area');
    e.stopPropagation();
  });
  $('body .mb-area-mob .site-nav .mega-menu .menu-lv-2 span.icon-dropdown').click(function (e) {
    const $self = $(this);
    const $subMenu = $(this).parent().next('.cm-mega-menu-filter-menu');
    $(this).parent().next('.cm-mega-menu-filter-menu').addClass('sub-menu-open');
    setTimeout(function () {
      _theme.focusTrap(
        $subMenu,
        function () {
          $subMenu.removeClass('sub-menu-open');
          $self.focus();
        },
        '[role="button"]'
      );
    }, 250);
  });
  $('button.go-fronf').click(function (e) {
    const $self = $(this);
    let $subMenu = $(this).closest('.cm-mega-menu-tp-1-col').find('.cm-mega-menu-filter-menu');

    if ($subMenu.length === 0) {
      $subMenu = $(this).closest('.cm-mega-menu-tp-1-menu-l2').find('.cm-mega-menu-dl-back');
    }

    if (_theme.isMobile) {
      $(this)
        .closest('.sub-menu-mobile')
        .find('*')
        .not($(this).closest('.cm-mega-menu-tp-1-col').find('.cm-mega-menu-filter-menu').find('*'))
        .not($('.cm-mega-menu-filter-menu'))
        .attr('aria-hidden', 'true');
    }
    $subMenu.addClass('sub-menu-open');
    setTimeout(function () {
      _theme.focusTrap(
        $subMenu,
        function () {
          $subMenu.removeClass('sub-menu-open');
          $self.focus();
        },
        '[role="button"]'
      );
    }, 250);
  });
  $('body .mb-area-mob .site-nav .mega-menu .menu-lv-2 span.icon-dropdown, button.go-fronf').on(
    'keydown',
    function (evt) {
      // $(this).parent().next().addClass('sub-menu-open');
      if (evt.which === 13 || evt.which === 32) {
        evt.target.click();
      }
    }
  );
};

_theme.removeElements = function () {
  const headerMob = document.querySelector('.header-bottom .header-mb');
  if (window.innerWidth < 1200) {
    const headerPanelTop = document.querySelector(
      '.wrapper-header-bt .header-pc .header-panel-top'
    );
    const headerFindStore = document.querySelector(
      '.header-top .top-message .find-a-store.header-top-bar'
    );
    headerPanelTop && headerPanelTop.remove();
    headerFindStore && headerFindStore.remove();
    ($('.header-top .top-message .find-a-store.header-top-bar ').remove(),
      $('.wrapper-header-bt .header-pc .header-panel-top').remove());
    $('.cm-footer-content').remove();
  } else {
    headerMob && headerMob.remove();
  }

  if (_theme.isIpad) {
    $('footer .foot-title.dropdow-mb').each(function (index, item) {
      const newElem =
        '<button type="button" aria-expanded="false" class="' +
        $(this).attr('class') +
        '">' +
        this.innerHTML +
        '</button>';
      $(this).replaceWith($(newElem));
    });
    $('footer.footer-wrapper .footer-pane').insertAfter(
      $('footer.footer-wrapper  .site-footer-inner')
    );

    $('.site-footer .dropdow-mb')
      .off('click.slideToggle')
      .on('click.slideToggle', function () {
        $(this).toggleClass('open');
        $(this).next().stop().slideToggle();
        $(this).attr('aria-expanded', this.classList.contains('open'));
      });
  } else {
    $('.mb-area-mob .site-nav-desktop [data-toggle-menu-mb]').attr({
      tabindex: -1,
      'aria-hidden': true,
    });
  }
};

_theme.initChatWidget = function () {
  if ($(window).width() < 768) {
    LiveChatWidget.call('hide');
    function onVisibilityChanged(data) {
      switch (data.visibility) {
        case 'maximized':
          break;
        case 'minimized':
          LiveChatWidget.call('hide');
          break;
        case 'hidden':
          break;
      }
    }
    LiveChatWidget.on('visibility_changed', onVisibilityChanged);
  }

  $(document).on('click', '.footer-pane-item.support-chat,.cart-order-link.contact', function () {
    if (window.LiveChatWidget) LiveChatWidget.call('maximize');
  });

  function onAvailabilityChanged(data) {
    if (data.availability === 'online') {
      document.querySelector(
        '.footer-pane-grid .footer-pane-item.support-chat .small-des'
      ).textContent = 'Chat';
    } else {
      document.querySelector(
        '.footer-pane-grid .footer-pane-item.support-chat .small-des'
      ).textContent = 'Support';
    }
    $('.footer-pane-item.support-chat .icon,.footer-pane-item.support-chat .content').removeClass(
      'hide'
    );
    $('.footer-pane-item.support-chat .footer-pane-loader').addClass('hide');
  }

  LiveChatWidget.on('availability_changed', onAvailabilityChanged);
};

_theme.loadAppScript = function () {
  if (!_theme.appsScripts || _theme.appsScripts.length === 0) return;

  // App Optimization Section code
  // if (window.AppOptimization && typeof AppOptimization.processDeferredApps === 'function') {
  //   AppOptimization.processDeferredApps();
  //   return;
  // }

  const initLiveChat =
    _theme.settings.livechat_enable && _theme.settings.livechat_type === 'default';
  const criticalScripts = _theme.appsScripts.filter(function (script_src) {
    let status = false;
    if (script_src.indexOf('searchanise') > -1) status = true;
    if (script_src.indexOf('searchserverapi') > -1) status = true;
    if (script_src.indexOf('klarna') > -1) status = true;
    if (script_src.indexOf('services.nofraud.com') > -1) status = true;
    if (script_src.indexOf('cjshpfy.cjpowered.com') > -1) status = true;
    if (script_src.indexOf('signifyd') > -1) status = true;

    return status;
  });

  const nonCriticalScripts = _theme.appsScripts.filter(function (script_src) {
    let status = true;
    if (script_src.indexOf('searchanise') > -1) status = false;
    if (script_src.indexOf('searchserverapi') > -1) status = false;
    if (script_src.indexOf('klarna') > -1) status = false;
    if (script_src.indexOf('services.nofraud.com') > -1) status = false;
    if (script_src.indexOf('cjshpfy.cjpowered.com') > -1) status = false;
    if (script_src.indexOf('signifyd') > -1) status = false;

    if (script_src.indexOf('wiser.expertvillagemedia.com') > -1) status = false; // appendig through "wiser.js" file
    return status;
  });

  criticalScripts.map(function (s) {
    appendScript(s);
  });

  let script_loaded = false;

  document.addEventListener('scroll', loadScriptOnScroll);
  function loadScriptOnScroll() {
    if (window.pageYOffset > 10 && !script_loaded) {
      window.ju_num = 'DD47F4B7-E44F-41C6-8126-66D05527DD9C';
      window.asset_host = '//cdn.jst.ai/';
      (function (i, s, o, g, r, a, m) {
        i[r] =
          i[r] ||
          function () {
            (i[r].q = i[r].q || []).push(arguments);
          };
        ((a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]));
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(window, document, 'script', asset_host + 'vck.js', 'juapp');
      script_loaded = true;
      nonCriticalScripts.map(function (s) {
        appendScript(s);
      });
      document.removeEventListener('scroll', loadScriptOnScroll);
    }
  }

  function appendScript(script_url) {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true; // s.defer = 'defer';
    s.src = script_url;
    const x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  }

  if (window.innerWidth < 768 && initLiveChat) _theme.initChatWidget();

  delete _theme.appsScripts;

  setTimeout(() => {
    $('.grecaptcha-badge').attr('role', 'complementary');
  }, 2000);
};

_theme.initGTM = function () {
  window.dataLayer = window.dataLayer || [];
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.onload = () => {
    dataLayer.push({ event: 'gtm.js', 'gtm.start': new Date().getTime(), 'gtm.uniqueEventId': 0 });
  }; // this part ensures PageViews is always tracked
  script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KG925N3';
  document.head.appendChild(script);
};

_theme.loadSection = function () {
  const fcp = document.querySelector('.fcp');
  if (fcp) fcp.remove();

  const sections = document.querySelectorAll('.section--async');
  if (sections.length === 0) return;
  const viewportHeight = Math.floor((window.innerHeight * 10) / 100) + 'px';

  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          //console.log('IntersectionRatio => ', entry.intersectionRatio, 'isVisible => ' , entry.isVisible);
          const section = entry.target;
          try {
            const section_json = JSON.parse(
              section.querySelector('[data-section-script]').textContent
            );
            section.innerHTML = section_json.html;
            if (section_json.type === 'home_featured_products') {
              _theme.Wishlist.init();
            }
            if (section_json.type === 'icon_wrapper') {
              const trustpilot = document.querySelector('trustpilot-summary');
              if (trustpilot) trustpilot.updateGlobalSrOnlyText();
            }
            setTimeout(_theme.tweakBVLayout, 3000);
            section.classList.add('section--async-loaded');
            observer.unobserve(section);
          } catch (err) {
            console.log('Error', err);
            observer.unobserve(section);
          }
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px ' + viewportHeight + ' 0px',
      threshold: 0.05,
    }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });
};

_theme.initLazyloadData = function () {
  const sections = document.querySelectorAll('[data-async]');
  if (sections.length === 0) {
    _theme.initNavigationEvents();
    return;
  }

  sections.forEach(function (section) {
    try {
      const section_json = JSON.parse(section.querySelector('[data-section-script]').textContent);
      section.innerHTML = '';
      section.innerHTML = section_json.html;
    } catch (err) {}
  });

  _theme.initNavigationEvents();
};

_theme.toggleAjaxModal = function (show, msg) {
  if (show && msg) {
    $('.ajax-error-modal .ajax-error-message').text(msg);
    $('.ajax-error-modal').fadeIn();
    setTimeout(function () {
      $('.ajax-error-modal').fadeOut();
    }, 2000);
  } else {
    $('.ajax-error-modal').fadeOut();
  }
};

_theme.redemptionPopup = function () {
  if ($('.redemption-popup').length === 0) return;
  if (_theme.Helpers.getCookie('redemtion_popup') == '') {
    setTimeout(function () {
      const d = new Date();
      d.setTime(d.getTime() + 3600 * 1000 * 24 * 365 * 1);
      const expires = 'expires=' + d.toUTCString();
      document.cookie = 'redemtion_popup' + '=' + 'expire_value' + ';' + expires;
      $('.redemption-popup').find('[data-redemption-content]').attr('tabindex', 0);
      // $('.redemption-popup').addClass('active').find('.title').focus();
      $('.redemption-popup').addClass('active').focus();
    }, 1000 * 60);
  }
  $(document).on('click', '.redemption-popup .close-popup', handleClosePopup);

  function handleClosePopup() {
    $('.redemption-popup').find('[data-redemption-content]').attr('tabindex', -1);
    $('.redemption-popup').removeClass('active');
    $(document).off('click', '.redemption-popup .close-popup', handleClosePopup);
  }
};

_theme.updateDOMOnResize = function () {
  window.onresize = debounce(function () {
    if (window.innerWidth > 767) {
      $('.mb-area-mob .site-nav-desktop [data-toggle-menu-mb]').attr({
        tabindex: -1,
        'aria-hidden': 'true',
      });
      $('footer.footer-wrapper .footer-pane').insertBefore(
        $('footer.footer-wrapper .site-footer-inner')
      );
    } else {
      $('.mb-area-mob .site-nav-desktop [data-toggle-menu-mb]').attr({
        tabindex: 0,
        'aria-hidden': 'false',
      });
      $('footer.footer-wrapper .footer-pane').insertAfter(
        $('footer.footer-wrapper .site-footer-inner')
      );
    }
  });

  if (window.innerWidth > 767) {
    window.onresize = debounce(function () {
      _theme.toggleZoomStyle();
    });
  }
};

_theme.toggleZoomStyle = function () {
  const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
  if (browserZoomLevel > 200) $('body').addClass('zoom-style-enable');
  else $('body').removeClass('zoom-style-enable');
};

_theme.ProductGridQuickView = (function () {
  const cacheQuickview = {};
  const cache_product = {};
  let activeId = null;
  let timer;

  function init() {
    $('[data-quickview-modal]').click(function (evt) {
      const isInside = $(evt.target).closest('.halo-modal-content').length ? true : false;
      if (!isInside) {
        if ($('body').hasClass('quickViewModal')) {
          $('body').removeClass('quickViewModal');
        }
        $(this).fadeOut();
        emptyQV();
        window.currentQuickViewGridIndex = null; // Clear stored grid index when quickview is closed
        if (activeId) {
          $('.product-item[data-product-id="' + activeId + '"] .quickview-button').focus();
          activeId = null;
        }
      }
    });

    $('.ajax-quickview .close-modal').click(function () {
      $('.ajax-success-modal.halo-modal.ajax-quickview').hide();
      $('body').removeClass('quickViewModal');
      emptyQV();
      window.currentQuickViewGridIndex = null; // Clear stored grid index when quickview is closed
      if (activeId) {
        $('.product-item[data-product-id="' + activeId + '"] .quickview-button').focus();
        $('.product-item[data-product-id="' + activeId + '"] .offer-quickview-button').focus();
        activeId = null;
      }
    });

    if (!_theme.isIpad) {
      $(document)
        .off('mouseenter', '.product-item .quickview-button')
        .on('mouseenter', '.product-item .quickview-button', function (evt) {
          timer = setTimeout(() => {
            _theme.track.trackView('Quickview');
          }, 300);
        });

      $(document)
        .off('mouseleave', '.product-item .quickview-button')
        .on('mouseleave', '.product-item .quickview-button', function (evt) {
          clearTimeout(timer);
        });
    }

    $(document)
      .off('click', '.product-item .quickview-button')
      .on('click', '.product-item .quickview-button', async function (evt) {
        evt.preventDefault();
        activeId = $(this).closest('.product-item').attr('data-product-id');
        const handle = $(this).data('id');
        if (!handle) return;

        _theme.track.trackClick('Quickview');

        const productData = extractCollectionProductData(this, handle);
        if (productData) {
          _theme.track.trackQuickViewOpen(productData);
        }

        if (cacheQuickview[handle]) {
          showQV(cacheQuickview[handle].html);
        } else {
          try {
            _theme.toggleLoading(1);
            const resp = await fetch('/products/' + handle + '?view=quickview');
            const text = await resp.text();
            cacheQuickview[handle] = { html: text };
            showQV(text, activeId);
            _theme.toggleLoading();
          } catch (err) {
            _theme.toggleLoading();
            _theme.Helpers.showNotification(err.message || 'Something went wrong');
          }
        }
      });

    $(document)
      .off('click', '.product-item [data-offer-quickview-button]')
      .on('click', '.product-item [data-offer-quickview-button]', async function (evt) {
        if (evt.type !== 'click') return;

        evt.preventDefault();
        activeId = $(this).closest('.product-item').attr('data-product-id');
        const handle = $(this).data('id');
        const variantId = $(this).data('vid');
        const c_handle = $(this).data('c_handle');
        if (!handle || !variantId) return;

        // Calculate grid index for this product
        const $productItem = $(this).closest('.product-item');
        const $productsContainer = $productItem.closest('[data-products-container]');
        let gridIndex = 0;

        if ($productsContainer.length) {
          // Find all grid items that are NOT banner items (exclude .pro-bann-grid)
          const $allGridItems = $productsContainer.find('.grid-item:not(.pro-bann-grid)');
          const $currentGridItem = $productItem.closest('.grid-item');
          gridIndex = $allGridItems.index($currentGridItem);
        }
        // Store grid index in the quickview modal for later use
        window.currentQuickViewGridIndex = gridIndex;

        _theme.track.trackClick('Quickview');

        const productData = extractCollectionProductData(this, handle);
        if (productData) {
          _theme.track.trackQuickViewOpen(productData);
        }

        const cacheKey = handle + '-' + variantId;
        if (cacheQuickview[cacheKey]) {
          showQV(cacheQuickview[cacheKey].html);
        } else {
          try {
            _theme.toggleLoading(1);
            // Use canonical product URL so quickview works regardless of collection filters
            let resp = await fetch(`/products/${handle}?view=quickview&variant=${variantId}`);
            if (c_handle == '') {
              resp = await fetch(`/products/${handle}?view=quickview&variant=${variantId}`);
            }
            const text = await resp.text();
            cacheQuickview[cacheKey] = { html: text };
            showQV(text, activeId);
            _theme.toggleLoading();
          } catch (err) {
            _theme.toggleLoading();
            _theme.Helpers.showNotification(err.message || 'Something went wrong');
          }
        }
      });

    // Helper function to extract product data from collection page product items
    function extractCollectionProductData(button, handle) {
      try {
        const productItem = button.closest('.product-item');
        if (!productItem) {
          return null;
        }

        // Get product data from JSON script tag
        let productData = null;

        // Look for script tag with data-product-json attribute
        const jsonScript = productItem.querySelector(
          'script[type="application/json"][data-product-json]'
        );
        if (jsonScript) {
          productData = JSON.parse(jsonScript.textContent.trim());
        } else {
          return null;
        }
        // Get product position/index - use dynamic grid index if available
        const productIndex =
          window.currentQuickViewGridIndex !== undefined
            ? window.currentQuickViewGridIndex + 1
            : Array.from(productItem.parentNode.children).indexOf(productItem) + 1;
        // Convert price from cents to dollars (Searchanise prices are already in dollars)
        const price = productData.price ? productData.price.toString() : '0';
        const compareAtPrice = productData.compareAtPrice
          ? productData.compareAtPrice.toString()
          : '0';

        return {
          productId: productData.id,
          productTitle: productData.title || '',
          productVendor: productData.vendor || '',
          productType: productData.collection_title || '',
          variantTitle: productData.variant_title || '',
          currency: 'USD',
          price: price,
          compareAtPrice: compareAtPrice,
          productPosition: productIndex,
          productDiscount: productData.discount || '0',
          collectionTitle: productData.collection_title || '',
          collectionHandle: productData.collection_handle || '',
        };
      } catch (error) {
        console.warn('Error extracting collection product data:', error);
        return null;
      }
    }

    function handleQuickViewMobAction(element, event) {
      event.preventDefault();
      $('body').addClass('quick-view-open');
      const $self = $(element);
      $activeElem = $self;
      let prod_url = $self.data('url');
      const prod_id = $self.data('id');
      const variantId = $self.data('vid');
      const c_handle = $self.data('c_handle');
      if (!prod_url || !prod_id || !variantId) return;

      // Calculate grid index for this product (mobile quickview)
      const $productItem = $self.closest('.product-item');
      const $productsContainer = $productItem.closest('[data-products-container]');
      let gridIndex = 0;

      if ($productsContainer.length) {
        // Find all grid items that are NOT banner items (exclude .pro-bann-grid)
        const $allGridItems = $productsContainer.find('.grid-item:not(.pro-bann-grid)');
        const $currentGridItem = $productItem.closest('.grid-item');
        gridIndex = $allGridItems.index($currentGridItem);
      }
      // Store grid index for later use
      window.currentQuickViewGridIndex = gridIndex;

      const productData = extractCollectionProductData(element, prod_id);
      if (productData) {
        _theme.track.trackQuickViewOpen(productData);
      }

      _theme.toggleLoading(1);
      const cacheKey = prod_id + '-' + variantId;
      if (cache_product[cacheKey]) {
        updateSideCartQvOffer(cache_product[cacheKey].html, prod_id);
        _theme.qvVariants();
      } else {
        // Build the correct URL for the request
        if (prod_url.indexOf('/products/') < 0) {
          prod_url = c_handle + '/' + prod_url + '?view=sidecart-qv&variant=' + variantId;
        } else {
          // If it's already a full product URL, add the view parameter
          const separator = prod_url.includes('?') ? '&' : '?';
          prod_url = prod_url + separator + 'view=sidecart-qv&variant=' + variantId;
        }
        $.get(prod_url, function (res) {
          cache_product[cacheKey] = { html: res };
          updateSideCartQvOffer(res, prod_id);
        })
          .done(function (res) {
            _theme.toggleLoading();
            _theme.qvVariants();
          })
          .fail(function (a) {
            _theme.toggleLoading();
            $self.removeClass('loading');
            // Show user-friendly error message
            const errorMessage =
              'Unable to load product details. Please try again or view the full product page.';
            if (
              typeof _theme !== 'undefined' &&
              _theme.Helpers &&
              _theme.Helpers.showNotification
            ) {
              _theme.Helpers.showNotification(errorMessage);
            } else {
              alert(errorMessage);
            }
          });
      }
    }

    let touchmoved_mob;
    $('body')
      .on('touchstart', '[data-offer-quickview-mob-button]', function () {
        touchmoved_mob = false;
      })
      .on('touchmove', '[data-offer-quickview-mob-button]', function () {
        touchmoved_mob = true;
      })
      .on('touchend', '[data-offer-quickview-mob-button]', function (e) {
        if (touchmoved_mob) {
          return;
        }
        handleQuickViewMobAction(this, e);
      });

    $('body').on('click', '[data-offer-quickview-mob-button]', function (e) {
      if ('ontouchstart' in window) {
        if (
          e.originalEvent.sourceCapabilities &&
          e.originalEvent.sourceCapabilities.firesTouchEvents
        ) {
          e.preventDefault();
          return;
        }
      }
      handleQuickViewMobAction(this, e);
    });
  }

  function updateSideCartQvOffer(res, prod_id) {
    $('.sidecart-qv').attr('data-id', prod_id);
    $('.sidecart-qv').addClass('offer-sidecart-qv');
    // Check if the required elements exist in the response
    const $res = $(res);
    const $sidecartQvCta = $res.find('.sidecart-qv-cta');
    // Use the helper function to get the best available content
    const contentInfo = getBestAvailableContent($res);
    if (contentInfo) {
      $('.sidecart-qv .sidecart-qv-body').html(contentInfo.element.html());
    } else {
      $('.sidecart-qv .sidecart-qv-body').html(
        '<div class="error-message">Product information not available. <a href="' +
          window.location.origin +
          '/products/' +
          prod_id +
          '" target="_blank">View full product page</a></div>'
      );
    }

    if ($sidecartQvCta.length > 0) {
      $('.sidecart-coll-cta').html($sidecartQvCta.html());
      $('.sidecart-qv-cta').html($sidecartQvCta.html());
    }

    setTimeout(function () {
      const imgSlickContainer = $('.sidecart-qv .sidecart-qv-images ul');
      if (imgSlickContainer.length > 0) {
        // Count actual slides before slick adds clone nodes
        const rawImgCount = imgSlickContainer.find('li').length;
        imgSlickContainer.on('init', function (b, c) {
          imgSlickContainer.closest('.sidecart-qv-images').removeClass('loading');
          // Disable next arrow when there is only one image
          if (rawImgCount <= 1) {
            imgSlickContainer
              .find('.slick-arrow.slick-next')
              .addClass('slick-disabled')
              .attr('aria-disabled', 'true');
          }
        });
        imgSlickContainer.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: !1,
          arrows: true,
        });
        $('.sidecart-qv-inner .sidecart-qv-images .slick-list .slick-track').attr(
          'role',
          'presentation'
        );
      }
    }, 500);

    // Only set first variant if swatch elements exist
    const availableSwatches = document.querySelectorAll(
      '.sidecart-qv .sidecart-qv-options .swatch-element.available'
    );
    if (availableSwatches.length > 0) {
      const firstInput = availableSwatches[0].querySelector('input');
      if (firstInput) {
        firstInput.checked = true;
      }
    }

    const c_v = getCurrentVariant();
    if (c_v) {
      const kl = document.querySelector('.sidecart-qv-klarna klarna-placement');
      kl && kl.setAttribute('data-purchase-amount', c_v.price);
    }
    _theme.toggleSideCartQv(1);
    _theme.Wishlist.init();
    _theme.toggleLoading();
    _theme.Helpers.refreshKlarna();

    _theme.focusTrap(
      $('.sidecart-qv'),
      function () {
        _theme.toggleSideCartQv();
        if ($activeElem) $activeElem.focus();
        $activeElem = null;
      },
      'details'
    );
  }
  function getCurrentVariant() {
    const b = $('.sidecart-qv'),
      c = b.find('form');
    if (c.find('.sidecart-qv-options input:checked').val()) {
      let d = null;
      try {
        const a = JSON.parse(b.find('script[data-json]').text());
        if (!a.available) return;
        const f = {},
          g = a.options.length;
        (c.find('.sidecart-qv-options .swatch').each(function () {
          f['option' + (parseInt($(this).attr('data-option-index')) + 1)] = $(this)
            .find('input:checked')
            .val();
        }),
          (d =
            a.variants.length > 1
              ? a.variants.filter(function (a) {
                  switch (g) {
                    case 1:
                      return f.option1 == a.option1;
                    case 2:
                      return f.option1 == a.option1 && f.option2 == a.option2;
                    case 3:
                      return (
                        f.option1 == a.option1 && f.option2 == a.option2 && f.option3 == a.option3
                      );
                  }
                })[0]
              : a.variants[0]));
      } catch (e) {
        console.log(e);
      }
      return d || null;
    }
  }

  function showQV(res, activeId) {
    emptyQV();
    const body = _theme.Helpers.stringToHTML(res);
    const $quickviewModal = $('[data-quickview-modal]');
    $('[data-quickview-modal] .halo-modal-body').html($(body).find('.product-wrapper').html());
    const productTitleText =
      $quickviewModal.find('[data-product-title-quickview]').text().trim() ||
      $quickviewModal.find('.product__title .h1').text().trim() ||
      $quickviewModal.find('.product__info-container h3.product__text').text().trim() ||
      $quickviewModal.find('.product-wrapper .product-single__title').text().trim() ||
      $quickviewModal.find('.product-wrapper [data-product-title]').text().trim();
    const modalContent = document.querySelector('[data-quickview-modal] .halo-modal-content');
    if (modalContent) {
      const ariaLabel = productTitleText
        ? `Quick view modal for ${productTitleText}`
        : 'Quick view modal';
      modalContent.setAttribute('aria-label', ariaLabel);
    }

    const $pdpOfferLabelElem =
      $quickviewModal.find('.product-shop [id*=pdp_label_] .bogopromoTitle') ||
      $quickviewModal.find('.product-shop [id*=pdp_label_]');
    if ($pdpOfferLabelElem.length) {
      const eventText = $pdpOfferLabelElem.text()?.trim() || 'PDP Offer Label';
      _theme.track.trackView(eventText);
    }

    $('[data-quickview-modal]').attr('data-source', activeId).fadeIn(1000, 'linear');
    $('[data-quickview-modal] .product__info-container h3.product__text').focus();
    $('body').addClass('quickViewModal');
    _theme.Wishlist.init();
    Shopify.PaymentButton && Shopify.PaymentButton.init();

    $('#model--quickview .product__media-item.slick-slide').attr('tabindex', '-1');
    if ('#model--quickview .product-thumb-slider li'.length) {
      $('#model--quickview .product-thumb-slider li button').removeAttr('tabindex');
    }
    _theme.focusTrap($('#model--quickview'), function () {
      $('.ajax-quickview .close-modal').click();
    });

    // Disable the next arrow in the QV thumbnail slider when there is only one image
    setTimeout(function () {
      const $qvThumbSlider = $('[data-quickview-modal] .product-thumb-slider');
      if ($qvThumbSlider.length) {
        const thumbCount = $qvThumbSlider.find('.thumbnail-list__item').length;
        const $nextBtn = $qvThumbSlider.find('.slick-arrow.slick-next');
        if (thumbCount <= 1) {
          $nextBtn.addClass('slick-disabled').attr('aria-disabled', 'true');
        }
      }
    }, 600);
  }

  function emptyQV() {
    $('[data-quickview-modal] .halo-modal-body').empty();
  }

  return { init: init };
})();

_theme.Wishlist = (function () {
  const WISHLIST_KEY = 'wishListsArr';
  let wishlist_arr = null;
  const isWishlistPage = $('body.template-page [data-wishlist-container]').length ? true : false;

  function init() {
    wishlistEvent();
    if ($('body.template-page [data-wishlist-container]').length) {
      initWishlistProductGrid();
    }
    updateWishlistStatus();
  }

  function getProductJsonFromContainer($container) {
    if (!$container || !$container.length) return null;

    const $script = $container.find('script[data-product-json]').first();
    if (!$script.length) return null;

    try {
      return JSON.parse($script.text().trim());
    } catch (error) {
      console.warn('Wishlist: invalid product JSON', error);
      return null;
    }
  }

  function wishlistEvent() {
    $('[data-icon-wishlist]')
      .off('click')
      .on('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        const $self = $(this);
        if ($self.hasClass('processing')) return;
        $self.addClass('processing');
        let $mainParent = $self.closest('.inner.product-item');
        let pjson = getProductJsonFromContainer($mainParent);
        if (!pjson) $mainParent = $self.parent();
        if (!pjson) pjson = getProductJsonFromContainer($mainParent);

        let $parent = $self.closest('[data-wishlist-container]');
        if ($parent.length === 0) $parent = $self.closest('.product-des');
        wishlist_arr = getWishlistHandles() || [];
        const handle = ($self.data('product-handle') || '').trim();
        if (!handle) {
          $self.removeClass('processing');
          return;
        }
        const item_index = wishlist_arr.indexOf(handle);
        // Check if ANY button for this product is already marked as added
        const isAdded = $('[data-product-handle="' + handle + '"]').hasClass('whislist-added');
        const p_id = $self.data('id');
        if (item_index !== -1 && isAdded) {
          removeProductFromWishlist(handle, p_id, $self);
          if (!wishlist_arr) {
            $('.wishlist-page').addClass('wishlist--empty');
          }
        } else {
          addProductToWishlist(handle, $self);
          sendWishlistTracking(pjson);
        }

        if (isWishlistPage) {
          let showAlert = false;
          if (evt.originalEvent && evt.originalEvent.pointerId === -1) showAlert = true;
          if (evt.buttons && evt.buttons === 1) showAlert = true;
          if (showAlert) {
            _theme.Helpers.showNotification('Product is removed from the wishlist');
          }
        }
        $self.removeClass('processing');
      });
  }

  function sendWishlistTracking(product) {
    if (!window.gtag || !product) return;

    gtag('event', 'add_to_wishlist', {
      currency: 'USD',
      value: product.price,
      items: [
        {
          item_id: product.id,
          item_name: product.title,
          index: 0,
          item_brand: product.vendor || '',
          item_category: product.collection_title,
          item_list_id: product.collection_id,
          item_list_name: 'Wishlist Products',
          item_variant: product.variant_title,
          price: product.price,
        },
      ],
    });
  }

  function updateWishlistStatus(title) {
    wishlist_arr = getWishlistHandles();
    const count = wishlist_arr ? wishlist_arr.length : 0;
    $('.wishlistCount').text(count);
    if (!wishlist_arr) return;
    wishlist_arr.map(function (handle) {
      const a = $(
        '.wishlist[data-product-handle="' +
          handle +
          '"], [data-icon-wishlist][data-product-handle="' +
          handle +
          '"]'
      );
      a.addClass('whislist-added');
      const prefix = title ? title : a.data('title') ? a.data('title') : '';
      const newLabel = window.inventory_text.remove_wishlist + ' ' + prefix;
      a.each(function () {
        const el = this;
        if (el === document.activeElement) {
          const handleBlur = function () {
            el.setAttribute('aria-label', newLabel);
            el.removeEventListener('blur', handleBlur);
          };
          el.addEventListener('blur', handleBlur);
        } else {
          el.setAttribute('aria-label', newLabel);
        }
      });
      a.find('.wishlist-text').text(window.inventory_text.remove_wishlist);
    });
  }

  function initWishlistProductGrid() {
    wishlist_arr = getWishlistHandles();
    if (!wishlist_arr) {
      $('.wishlist-page').addClass('wishlist--empty');
    }
    if (!wishlist_arr) return;
    _theme.toggleLoading(1);
    const placeholder_index = wishlist_arr.indexOf('[[Product_Handle]]');
    if (placeholder_index > -1) wishlist_arr.splice(placeholder_index, 1);
    const temp_arr = wishlist_arr.concat([]);
    const products = [];
    fetchData();
    function fetchData() {
      if (temp_arr.length) {
        const handle = temp_arr.shift();
        fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.json();
          })
          .then(function (res) {
            products.push(res);
            fetchData();
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        if (products.length) {
          $('.wishlist-page').removeClass('wishlist--empty');
          const $grid = $('[data-wishlist-content] .wrapper-overflow');
          $grid.attr('aria-rowcount', products.length);
          // Clear container before rendering to prevent duplicates
          $grid.find('.grid-item').remove();
          products.map(function (p, index) {
            buildWishlistProductGrid(p, index);
          });
          initWishlistProductGridEvents();
          wishlistEvent();
        } else {
          $('.wishlist-page').addClass('wishlist--empty');
        }
        _theme.toggleLoading();
      }
    }
  }

  function initWishlistProductGridEvents() {
    $(document)
      .off('click', '[data-btn-addtocart]')
      .on('click', '[data-btn-addtocart]', function (evt) {
        evt.preventDefault();
        const vid = $(this).closest('form').find('[name="id"]').val();
        if (!vid) return;
        const self = this;
        $(this).closest('[data-wishlist-container]').addClass('processing');
        $('#minicart-sr-only').removeAttr('aria-hidden').text('Adding');
        _theme.toggleLoading(1);

        _theme.Helpers.addProductToCart(vid, 1, null, function (resp) {
          $('#minicart-sr-only').text('Added successfully');
          _theme.MiniCart.lineItemChangeCallBack(resp, function () {
            $('#minicart-sr-only').text('').attr('aria-hidden', 'true');
            _theme.toggleLoading();
            $('[data-wishlist-container]').removeClass('processing');
            _theme.toggleSideCart(
              1,
              function () {
                self.focus();
              },
              true
            );
          });
        });
      });
  }

  function buildWishlistProductGrid(t, index) {
    if (!t) return;
    const $wishlistContainer = $('[data-wishlist-container]');
    $wishlistContainer.attr('role', 'rowgroup');
    let e = '',
      i = Shopify.formatMoney(t.price_min, window.money_format);
    ((e +=
      '<div class="grid-item" role="row" aria-rowindex="' +
      (index + 1) +
      '" data-wishlist-added="wishlist-' +
      t.id +
      '">'),
      (e +=
        '<div role="presentation" class="inner product-item" data-product-id="product-' +
        t.handle +
        '">'),
      (e += '<div role="cell" class="column col-img"><div class="product-image">'),
      (e += '<div class="product-grid-image">'),
      (e +=
        '<a href="' + t.url + '"><img src="' + t.featured_image + '" alt="' + t.title + '" /></a>'),
      (e += '</div></div></div>'),
      (e += '<div role="cell" class="column col-prod">'),
      (e += '<div class="product-vendor">'),
      (e +=
        '<a aria-label="View all perfumes & colognes from ' +
        t.vendor +
        '" href="/collections/vendors?q=' +
        t.vendor +
        '">' +
        t.vendor +
        '</a></div>'),
      (e +=
        '<a class="product-title" href="' +
        t.url +
        '" aria-label="' +
        t.title +
        '">' +
        t.title +
        '</a></div>'),
      (e +=
        '<div role="cell" class="column col-price text-center"><div class="p-price">' +
        i +
        '</div></div>'),
      (e +=
        '<div role="cell" class="column col-remove text-center"><button data-title="' +
        t.title +
        '" type="button" aria-label="Remove ' +
        t.title +
        ' from the wishlist" class="whislist-added" href="#" data-product-handle="' +
        t.handle +
        '" data-icon-wishlist data-id="' +
        t.id +
        '"><span class="visually-hidden">Remove ' +
        t.title +
        ' from the wishlist</span><svg class="closemnu" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 357 357" xml:space="preserve"><g><g><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></g></g></svg></button></div>'),
      (e += '<div role="cell" class="column col-options text-center">'),
      (e +=
        '<form action="/cart/add" method="post" class="variants" id="-' +
        t.id +
        '" data-id="product-actions-' +
        t.id +
        '" enctype="multipart/form-data">'),
      t.available
        ? (1 == t.variants.length &&
            (e +=
              '<button data-btn-addToCart aria-controls="minicart-sr-only" class="btn add-to-cart-btn" type="submit" data-form-id="#-' +
              t.id +
              '" >' +
              window.inventory_text.add_to_cart +
              '</button><input type="hidden" name="id" value="' +
              t.variants[0].id +
              '" />'),
          t.variants.length > 1 &&
            (e +=
              '<a class="btn" aria-label="' +
              window.inventory_text.select_options +
              ' for ' +
              t.title +
              '" href="' +
              t.url +
              '">' +
              window.inventory_text.select_options +
              '</a>'))
        : (e +=
            '<button data-btn-addToCart class="btn add-to-cart-btn" type="submit" disabled="disabled">' +
            window.inventory_text.unavailable +
            '</button>'),
      (e += '</form></div>'),
      (e += '</div></div>'),
      $wishlistContainer.append(e));
  }

  function addProductToWishlist(handle, $self, callback) {
    if (!handle) return;
    const title = $self.data('title');
    wishlist_arr = getWishlistHandles() || [];
    const item_index = wishlist_arr.indexOf(handle);
    if (item_index !== -1) {
      // Still update the buttons just in case
      $('[data-product-handle="' + handle + '"]').addClass('whislist-added');
      return;
    }
    wishlist_arr.push(handle);
    // Enforce uniqueness
    wishlist_arr = [...new Set(wishlist_arr)];

    const $allButtons = $('[data-product-handle="' + handle + '"]');
    $allButtons.addClass('whislist-added');
    $allButtons.find('.wishlist-text').text(title + ' ' + window.inventory_text.remove_wishlist);
    $allButtons.find('[data-aria-live]').text('Added to wishlist');

    saveWishlistProducts();
    // setTimeout(() => {
    updateWishlistStatus(title);
    // }, 300);
    if (callback && typeof callback === 'function') callback();
  }

  function removeProductFromWishlist(handle, p_id, $self, callback) {
    if (!handle) return;
    wishlist_arr = getWishlistHandles();
    if (!wishlist_arr) return;
    const title = $self.data('title');
    const item_index = wishlist_arr.indexOf(handle);
    if (item_index === -1) {
      $('[data-product-handle="' + handle + '"]').removeClass('whislist-added');
      return;
    }
    wishlist_arr.splice(item_index, 1);
    $self.removeClass('whislist-added');
    $self.find('.wishlist-text').text(window.inventory_text.add_wishlist);
    const newLabel = window.inventory_text.add_wishlist + ' ' + title;
    if ($self[0] === document.activeElement) {
      const el = $self[0];
      const handleBlur = function () {
        el.setAttribute('aria-label', newLabel);
        el.removeEventListener('blur', handleBlur);
      };
      el.addEventListener('blur', handleBlur);
    } else {
      if ($self[0]) $self[0].setAttribute('aria-label', newLabel);
    }
    $self.find('[data-aria-live]').text('Removed from wishlist');
    const datId = $self.attr('data-id');
    if (window.enable_wishlist_fix !== false) {
      document.querySelectorAll('[data-product-handle="' + handle + '"]').forEach(function (button) {
        button.classList.remove('whislist-added');
      });
    } else {
      $('.common-product-grid').find(`button[data-id=${datId}]`).removeClass('whislist-added');
    }

    saveWishlistProducts();
    // setTimeout(() => {
    updateWishlistStatus();
    // }, 300);
    $('[data-wishlist-added="wishlist-' + p_id + '"]').length &&
      $('[data-wishlist-added="wishlist-' + p_id + '"]').remove();
    if (callback && typeof callback === 'function') callback();
  }

  function saveWishlistProducts() {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist_arr));
  }

  function getWishlistHandles() {
    wishlist_arr = JSON.parse(localStorage.getItem(WISHLIST_KEY));
    if (!wishlist_arr || wishlist_arr.length === 0) return null;

    return wishlist_arr;
  }

  // wishlist function end

  // wishlist removal function start
  function removeFromWishlistSilently(handle) {
    if (!handle) return;
    const arr = getWishlistHandles();
    if (!arr) return;
    const idx = arr.indexOf(handle);
    if (idx === -1) return;
    arr.splice(idx, 1);
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr));
    // Reset wishlist button state on page
    const $btn = $('[data-icon-wishlist][data-product-handle="' + handle + '"]');
    $btn.removeClass('whislist-added');
    $btn
      .find('.wishlist-text')
      .text((window.inventory_text && window.inventory_text.add_wishlist) || 'Save To Wishlist');
    const addLabel =
      (window.inventory_text && window.inventory_text.add_wishlist) || 'Add to wishlist';
    const title = $btn.data('title') || '';
    $btn.each(function () {
      this.setAttribute('aria-label', addLabel + ' ' + title);
    });
    $btn.find('[data-aria-live]').text('Removed from wishlist');
    // Remove product row on wishlist page
    const p_id = $btn.attr('data-id');
    if (p_id) {
      $('[data-wishlist-added="wishlist-' + p_id + '"]').remove();
    }
    updateWishlistStatus();
    // Show empty state if wishlist is now empty
    if (!arr.length) {
      $('.wishlist-page').addClass('wishlist--empty');
    }
  }
  // wishlist removal function end

  return {
    init: init,
    getWishlistHandles: getWishlistHandles,
    updateWishlistStatus: updateWishlistStatus,
    initWishlistProductGrid: initWishlistProductGrid,
    addProductToWishlist: addProductToWishlist,
    removeProductFromWishlist: removeProductFromWishlist,
    removeFromWishlistSilently: removeFromWishlistSilently,
  };
})();

_theme.MiniCart = (function () {
  const isCartPage = document.querySelector('body.template-cart');
  const offerConfig = _theme.gwpConfig;
  let cartjson = _theme.gwpConfig.cart;
  let activeLineIndex = null,
    activeOperation = null,
    activeItemTitle = '';

  let minicartContentLoaded = false;
  let minicartContentLoading = false;
  let prepareOnOpenPromise = null;
  let minicartPrefetchPromise = null;
  let minicartPrefetchCache = null;

  function syncCartOffers() {
    if (isCartPage) return;
    initGWP();
    initAutoFreeGift();
  }

  function deferSyncCartOffers() {
    if (isCartPage) return;

    requestAnimationFrame(function () {
      syncCartOffers();
    });
  }

  function setMinicartLoadingState(isLoading) {
    const $dropdown = $('#dropdown-cart');
    const $loading = $dropdown.find('[data-minicart-loading]');

    if (isLoading) {
      $dropdown.addClass('processing');
      if ($loading.length) $loading.removeAttr('hidden');
      return;
    }

    $dropdown.removeClass('processing');
    if ($loading.length) $loading.attr('hidden', true);
  }

  function applyMinicartGwp(newMiniCart, $dropdown) {
    const minicartGwp = newMiniCart?.querySelector('minicart-block .minicart-gwp-fetch');
    const $gwpTarget = $dropdown.find('[data-minicart-gwp]');

    if (!minicartGwp || !$gwpTarget.length) return;

    $gwpTarget.html(minicartGwp.innerHTML);
    deferSyncCartOffers();
  }

  function applyMinicartSectionData(data) {
    if (!data?.minicart) return false;

    const newMiniCart = _theme.Helpers.stringToHTML(data.minicart);
    if (!newMiniCart) return false;

    const $dropdown = $('#dropdown-cart');
    const minicartProductList = newMiniCart.querySelector('minicart-block .mini-products-list');
    const minicartSummary = newMiniCart.querySelector('minicart-block .summary');
    const cartScript = newMiniCart.querySelector('minicart-block [data-cart-json]');

    if (minicartProductList) {
      $dropdown.find('[data-minicart-products]').html(minicartProductList.innerHTML);
    }

    if (minicartSummary) {
      $dropdown.find('.summary').html(minicartSummary.innerHTML);
    }

    if (cartScript) {
      cartjson = JSON.parse(cartScript.textContent);
    }

    applyMinicartGwp(newMiniCart, $dropdown);

    minicartContentLoaded = true;
    bindMinicartLineItemEvents();
    return true;
  }

  function prefetchMinicart() {
    if (minicartContentLoaded || minicartPrefetchCache || minicartPrefetchPromise || isCartPage) {
      return;
    }

    const cartCount = parseInt($('#dropdown-cart .cart_count').first().text(), 10) || 0;
    if (cartCount === 0) return;

    const root = window.Shopify?.routes?.root || '/';

    minicartPrefetchPromise = fetch(`${root}?sections=minicart`, { priority: 'low' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(`Minicart prefetch failed: ${response.status}`);
        }

        return response.json();
      })
      .then(function (data) {
        minicartPrefetchCache = data;
        return data;
      })
      .catch(function () {
        minicartPrefetchCache = null;
      })
      .finally(function () {
        minicartPrefetchPromise = null;
      });
  }

  async function prepareOnOpen() {
    if (isCartPage) return;

    if (prepareOnOpenPromise) return prepareOnOpenPromise;

    const cartCount = parseInt($('#dropdown-cart .cart_count').first().text(), 10) || 0;
    const needsMinicart = cartCount > 0 && !minicartContentLoaded;
    const needsLoyalty =
      typeof _theme.syncLoyaltyCartAttributes === 'function' && !_theme.loyaltyAttributesSynced;

    if (!needsMinicart && !needsLoyalty) {
      if (cartCount > 0) deferSyncCartOffers();
      return;
    }

    _theme.toggleLoading(1);
    if (needsMinicart) setMinicartLoadingState(true);

    prepareOnOpenPromise = (async () => {
      const parallelTasks = [];

      if (needsLoyalty) {
        parallelTasks.push(_theme.syncLoyaltyCartAttributes());
      }

      if (needsMinicart) {
        parallelTasks.push(loadMinicartContent({ manageLoadingState: false }));
      }

      await Promise.all(parallelTasks);

      if (cartCount > 0) deferSyncCartOffers();
    })().catch(function (error) {
      console.error('Minicart prepareOnOpen failed:', error);
    });

    return prepareOnOpenPromise.finally(function () {
      _theme.toggleLoading();
      setMinicartLoadingState(false);
      prepareOnOpenPromise = null;
    });
  }

  async function loadMinicartContent(options = {}) {
    const { manageLoadingState = true } = options;

    if (minicartContentLoaded || minicartContentLoading || isCartPage) return;

    const cartCount = parseInt($('#dropdown-cart .cart_count').first().text(), 10) || 0;
    if (cartCount === 0) return;

    if (minicartPrefetchCache) {
      applyMinicartSectionData(minicartPrefetchCache);
      minicartPrefetchCache = null;
      return;
    }

    minicartContentLoading = true;
    if (manageLoadingState) {
      _theme.toggleLoading(1);
      setMinicartLoadingState(true);
    }

    try {
      if (minicartPrefetchPromise) {
        const prefetched = await minicartPrefetchPromise;
        if (applyMinicartSectionData(prefetched)) return;
      }

      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}?sections=minicart`, { priority: 'high' });

      if (!response.ok) {
        throw new Error(`Minicart section request failed: ${response.status}`);
      }

      const data = await response.json();
      applyMinicartSectionData(data);
    } catch (error) {
      console.error('Failed to load minicart content:', error);
    } finally {
      minicartContentLoading = false;
      if (manageLoadingState) {
        _theme.toggleLoading();
        setMinicartLoadingState(false);
      }
    }
  }

  function initMinicartShell() {
    $('[data-cart-toggle]')
      .off('click.minicartLazyLoad mouseenter.minicartPrefetch focus.minicartPrefetch')
      .on('click.minicartLazyLoad', function () {
        _theme.toggleSideCart(1, null, false);
        $(this).blur();
        setTimeout(function () {
          $('.cart-title a.close-cart').focus();
        }, 5000);
      })
      .on('mouseenter.minicartPrefetch focus.minicartPrefetch', prefetchMinicart);

    $('#dropdown-cart')
      .find('[data-checkout-btn]')
      .off('click.minicartCheckout')
      .on('click.minicartCheckout', async function (evt) {
        evt.preventDefault();
        await prepareOnOpen();

        if (typeof gtag !== 'undefined') {
          gtag('event', 'checkout_button_clicked', { origin: 'Sidecart' });
        }

        _theme.toggleLoading(1);
        setTimeout(function () {
          window.location.href = '/checkout';
        }, 500);
      });

    $('#dropdown-cart .exit.close-cart')
      .off('click.minicartClose')
      .on('click.minicartClose', function () {
        _theme.toggleSideCart(false, null, false);
      })
      .on('blur', function () {
        $(this).attr('aria-label', 'Close modal');
      });
  }

  function bindMinicartLineItemEvents() {
    $('#dropdown-cart .mini-products-list .btn-remove')
      .off()
      .on('click', function (evt) {
        evt.preventDefault();
        const $self = $(this);

        const $parent = $(this).closest('[line-index]');
        const lineIndex = $parent.attr('line-index');
        if (!lineIndex) return;

        const $input = $parent.find('input[name="updates[]"]');
        const totalQty = parseInt($parent.attr('data-total-qty')) || 0;
        const finalQty = 0;

        if ($input.length) {
          $input.val(0);
          const rawInput = $input[0];
          if (rawInput._validationTimeout) {
            clearTimeout(rawInput._validationTimeout);
            rawInput._validationTimeout = null;
          }
          $input.removeAttr('aria-invalid');
          $input.attr('aria-valuenow', '0');
          const errorId = $input.attr('aria-describedby');
          if (errorId) {
            const errorElement = document.getElementById(errorId);
            if (errorElement) {
              errorElement.textContent = '';
            }
          }
        }

        $(this).parent().find('.button').addClass('disabled');
        disableCartClick(true);
        updateStatusAccessibility(lineIndex, 'remove', 'in-progress');

        _theme.Helpers.changeLineItemQty(lineIndex, finalQty, false, function (cart) {
          lineItemChangeCallBack(cart, function () {
            updateStatusAccessibility(lineIndex, 'remove', 'done', 1, cart);
          });
        });
      });

    $('#dropdown-cart .mini-products-list .quantity-box .button')
      .off()
      .on('click', function (evt) {
        const $statusRegion = $(this).closest('[data-block-qty]').find('[data-aria-live]');

        const $parent = $(this).closest('[line-index]');
        const lineIndex = $parent.attr('line-index');
        if (!lineIndex) return;

        const totalQty = parseInt($parent.attr('data-total-qty')) || 0;
        const isPlus = $(this).hasClass('plus');
        const lineItemId = $parent.attr('id').split('-')[2];
        const $input = $(this).parent().find('input[name="updates[]"]');
        let qty = parseInt($input.val()) || 0;
        let finalQty = isPlus ? totalQty + 1 : totalQty - 1;

        const cartVariantInventory = $(this).parent().find('.cartVariantInventory');
        const miniCartError = document.querySelectorAll('.mini-cart-error-msg')[lineIndex - 1];
        let quantityLimit = null;
        if (Number(lineItemId) === cartVariantInventory.data('vid')) {
          quantityLimit = cartVariantInventory.data('quant');
        }

        if (isPlus) {
          if (totalQty == quantityLimit) {
            $(this).parent().find('.button.plus').addClass('disableQuantitySelector');
            miniCartError.innerHTML = 'You have reached maximum cart limit for this product';
            setTimeout(() => {
              miniCartError.innerHTML = '';
            }, 3000);
            return;
          }
        }

        qty = isPlus ? (qty += 1) : (qty -= 1);
        qty = qty < 0 ? 0 : qty;
        finalQty = finalQty < 0 ? 0 : finalQty;
        $input.val(qty);
        if ($input.length && typeof _theme.validateMinicartInput === 'function') {
          const isValid = _theme.validateMinicartInput($input[0], qty);
          if (!isValid) return;
        }

        if (finalQty === 0) {
          updateStatusAccessibility(lineIndex, 'remove', 'in-progress');
        } else {
          if (isPlus) updateStatusAccessibility(lineIndex, 'plus', 'in-progress');
          else updateStatusAccessibility(lineIndex, 'minus', 'in-progress');
        }

        $(this).parent().find('.button').addClass('disabled');
        disableCartClick(true);
        _theme.Helpers.changeLineItemQty(
          lineIndex,
          finalQty,
          false,
          function (cart) {
            lineItemChangeCallBack(cart, function () {
              if (finalQty === 0) {
                updateStatusAccessibility(lineIndex, 'remove', 'done', 1, cart);
              } else {
                if (isPlus) updateStatusAccessibility(lineIndex, 'plus', 'done', 1, cart);
                else updateStatusAccessibility(lineIndex, 'minus', 'done', 1, cart);
              }
            });
          },
          handleErrorCallBack
        );
      });
  }

  function handleErrorCallBack(err) {
    $('#dropdown-cart').find('.quantity-box .button.minus').removeClass('disabled');
    disableCartClick(false);
  }

  function lineItemChangeCallBack(resp, callback) {
    minicartPrefetchCache = null;

    const newMiniCart = _theme.Helpers.stringToHTML(resp.sections.minicart);
    const cartScript = newMiniCart.querySelector('minicart-block [data-cart-json]');
    const cart = JSON.parse(cartScript.textContent);
    if (resp.sections) {
      cart.sections = resp.sections;
      cart.section_url = resp.section_url;
    }

    cartjson = cart;

    $('[data-cart-count]').text(cart.item_count);

    const $DropdownCart = $('#dropdown-cart');
    $('.cart_count').text(cart.item_count);
    minicartContentLoaded = true;

    if (cart.item_count === 0) {
      minicartContentLoaded = false;
      $DropdownCart
        .find('[data-minicart-products]')
        .html('<p class="minicart-loading" data-minicart-loading hidden>Loading your cart…</p>');
      $DropdownCart.find('[data-minicart-gwp]').empty();
      $DropdownCart.addClass('cart--empty');
      $('#dropdown-cart .cart-recommended-products .new-products-grid').slick('refresh');
      setTimeout(function () {
        if (typeof _theme.applyCartRecA11y === 'function') _theme.applyCartRecA11y();
      }, 100);
      disableCartClick(true);

      const minicartProgress = newMiniCart.querySelector('minicart-block .minicart-progress-fetch');
      if (minicartProgress) {
        $DropdownCart.find('.minicart-progress-wrapper').html(minicartProgress.innerHTML);
      }

      $('#dropdown-cart .text-continue .new-cart-btn').attr({ tabindex: '0' }).focus();
      $('#dropdown-cart .cart_empty').attr({ role: 'alert' });
      _theme.updateGWP(cart);
      _theme.focusTrap($('#dropdown-cart'), function () {
        _theme.toggleSideCart(false, null, true);
      });
    } else {
      if (newMiniCart) {
        const minicartProductList = newMiniCart.querySelector('minicart-block .mini-products-list');
        const minicartSummary = newMiniCart.querySelector('minicart-block .summary');
        const minicartProgress = newMiniCart.querySelector(
          'minicart-block .minicart-progress-fetch'
        );

        $DropdownCart.find('[data-minicart-products]').html(minicartProductList.innerHTML);
        $DropdownCart.find('.summary').html(minicartSummary.innerHTML);
        applyMinicartGwp(newMiniCart, $DropdownCart);
        if (minicartProgress) {
          $DropdownCart.find('.minicart-progress-wrapper').html(minicartProgress.innerHTML);
        }
        _theme.updateGWP(resp);

        $DropdownCart.removeClass('cart--empty');
        $DropdownCart.find('.quantity-box .button').removeClass('disabled');
        disableCartClick(false);
        setTimeout(function () {
          $(
            '#dropdown-cart .has-items-wrapper .cart-recommended-products .new-products-grid'
          ).slick('refresh');
        }, 50);

        bindMinicartLineItemEvents();

        if (callback && typeof callback === 'function') callback(cart);
        else {
          if (activeLineIndex) {
            if (activeOperation === 'plus')
              updateStatusAccessibility(activeLineIndex, 'plus', 'done', 1, cart);
            else updateStatusAccessibility(activeLineIndex, 'minus', 'done', 1, cart);
          }
        }
      } else {
        $.ajax({
          type: 'get',
          url: '/cart/?view=minicart',
          success: function (data) {
            // const cartjson = $DropdownCart.find('.summary [data-cartjson]').text();
            // if(cart.sections && cart.sections.gwp){
            //   $(cart.sections.gwp).find('.gwp')
            // }
            $DropdownCart.find('.mini-products-list').replaceWith($(data)[0]);
            $DropdownCart.find('.summary').replaceWith($(data)[2]);
            if ($(data).find('.minicart-progress-fetch').length) {
              $DropdownCart
                .find('.minicart-progress-wrapper')
                .html($(data).find('.minicart-progress-fetch').html());
            }
            _theme.updateGWP(cart);

            // if($(data).find('gwp-block').length){
            //   $('gwp-block').replaceWith($(data).find('gwp-block'));
            // }

            $DropdownCart.removeClass('cart--empty');
            $DropdownCart.find('.quantity-box .button').removeClass('disabled');
            disableCartClick(false);
            setTimeout(function () {
              $(
                '#dropdown-cart .has-items-wrapper .cart-recommended-products .new-products-grid'
              ).slick('refresh');
            }, 50);

            bindMinicartLineItemEvents();

            if (callback && typeof callback === 'function') callback(cart);
            else {
              if (activeLineIndex) {
                if (activeOperation === 'plus')
                  updateStatusAccessibility(activeLineIndex, 'plus', 'done', 1, cart);
                else updateStatusAccessibility(activeLineIndex, 'minus', 'done', 1, cart);
              }
            }
          },
          error: function () {
            _theme.Helpers.showNotification($.parseJSON(err.responseText).description);
          },
        });
      }
    }
  }

  function updateStatusAccessibility(lineIndex, operation, status, shouldEmpty, cart) {
    const miniCartSrOnly = $('#minicart-sr-only');
    const $lineitemElem = $(
      '#dropdown-cart .mini-products-list .item[line-index="' + lineIndex + '"]'
    );
    if (!lineIndex) $('[data-aria-live]').text('');
    if (!lineIndex || !operation) return;

    miniCartSrOnly.removeAttr('aria-hidden');

    if (status === 'in-progress') {
      activeLineIndex = lineIndex;
      const productTitle = $lineitemElem.find('.product-name').text().trim() || 'item';
      activeItemTitle = productTitle;
      if (operation === 'plus') {
        miniCartSrOnly.text('please wait. increasing quantity');
        activeOperation = 'plus';
      } else if (operation === 'remove') {
        miniCartSrOnly.text('please wait. removing ' + productTitle + ' from the cart');
      } else {
        miniCartSrOnly.text('please wait. decreasing quantity');
        activeOperation = 'minus';
      }
    }

    if (status === 'done') {
      if (operation === 'remove') {
        miniCartSrOnly.text('Removed ' + activeItemTitle + ' from the cart');
      }

      if (cart && cart.item_count > 0) {
        if (operation === 'plus') {
          miniCartSrOnly.text('Increased successfully by 1');
        } else if (operation == 'remove') {
          _theme.focusFirstTabbable($('#dropdown-cart .mini-products-list'));
        } else miniCartSrOnly.text('Decreased successfully by 1');

        if ($lineitemElem.length > 0 && operation !== 'remove') {
          $lineitemElem.find('[data-block-qty] .' + operation).focus();
        }
      } else {
        $('#dropdown-cart .new-cart-btn').attr({ tabindex: '0' }).focus();
        $('#dropdown-cart .cart_empty').attr({ role: 'alert' });
      }

      activeLineIndex = null;
      activeOperation = null;
    }

    if (shouldEmpty) {
      setTimeout(function () {
        miniCartSrOnly.text('');
        miniCartSrOnly.attr('aria-hidden', 'true');
      }, 2000);
    }
  }

  function disableCartClick(disable) {
    if (disable) $('#dropdown-cart').addClass('processing');
    else $('#dropdown-cart').removeClass('processing');
  }

  function initGWP() {
    let isAdding = false,
      result = null;
    if (!offerConfig || !offerConfig.gwp) return;
    if (offerConfig.gwp.enable && offerConfig.gwp_auto.enable) return; // Can't run both offer at a time

    init();

    if ($('[data-gwp-trigger]').length) {
      run();
    }

    function init() {
      const gwp = offerConfig.gwp;
      result = getApplicableData(cartjson, gwp);

      const isBelowThreshold = !$('gwp-block [data-gwp-modal]').length;

      if (result.giftLineItem && (isBelowThreshold || !result.applicableOffer)) {
        _theme.Helpers.changeLineItemQty(result.giftLineItem.key, 0, 1, lineItemChangeCallBack);
      } else if (result.giftLineItem && result.giftLineItem.quantity > 1) {
        _theme.Helpers.changeLineItemQty(result.giftLineItem.key, 1, 1, lineItemChangeCallBack);
      }
    }

    function getApplicableData(cart, gwp) {
      const result = {
        giftLineItem: null,
        applicable: false,
        applicableOffer: null,
        giftLineItemIndex: -1,
      };

      if (!cart || !cart.items || !Array.isArray(cart.items) || cart.item_count === 0) return result;

      let cartTotal = cart.total_price;
      const giftLineItems = cart.items.filter(
        ({ properties = {} }) => properties?._type === 'gwp' && properties?._discAmount != null
      );
      let giftLineItem = giftLineItems[0];
      let giftLineItemIndex = cart.items.findIndex(
        ({ properties = {} }) => properties?._type === 'gwp' && properties?._discAmount != null
      );

      if (!giftLineItem && gwp.offers && gwp.offers.length) {
        const gwpVariantIds = new Set();
        for (const offer of gwp.offers) {
          for (const prod of offer.products || []) {
            gwpVariantIds.add(Number(prod.variant_id));
          }
        }
        giftLineItemIndex = cart.items.findIndex((item) =>
          gwpVariantIds.has(Number(item.variant_id))
        );
        if (giftLineItemIndex > -1) giftLineItem = cart.items[giftLineItemIndex];
      }
      if (giftLineItem) cartTotal -= giftLineItem.final_line_price;
      cartTotal /= 100;
      const qualifyingOffers = (gwp.offers || []).filter(
        (offer) => cartTotal >= Number(offer.threshold)
      );
      const applicableOffer = qualifyingOffers.length
        ? qualifyingOffers[qualifyingOffers.length - 1]
        : null;

      if (applicableOffer) {
        result['applicableOffer'] = applicableOffer;
        if (!giftLineItem) result['applicable'] = true;
      }

      if (giftLineItem) {
        result['giftLineItem'] = giftLineItem;
        result['giftLineItemIndex'] = giftLineItemIndex;

        if (applicableOffer) {
          const offerHasAddedGiftLine = applicableOffer.products.some(
            (prod) => Number(prod.variant_id) === Number(giftLineItem.variant_id)
          );
          result['applicable'] =
            offerHasAddedGiftLine &&
            Number(applicableOffer.discAmount) === Number(giftLineItem.properties?._discAmount);
        } else {
          result['applicable'] = false;
        }
      }

      if (giftLineItems.length > 1) {
        result['applicable'] = false;
      }

      if (!gwp.enable) result['applicable'] = false;

      return result;
    }

    function openGWPModal(evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
      }

      const modalElement = $('[data-gwp-modal]');
      if (!modalElement.length) return;

      const targetElement =
        evt?.currentTarget || evt?.target?.closest?.('[data-gwp-trigger]') || null;
      if (!targetElement) return;

      const isExpanded = targetElement.getAttribute('aria-expanded') === 'true';

      // Toggle aria-expanded attribute
      targetElement.setAttribute('aria-expanded', String(!isExpanded));

      if (!isExpanded) {
        // If not expanded, open the modal and enable focus trap
        modalElement.attr('aria-hidden', 'false').stop().slideDown();
        setTimeout(function () {
          const toHide = $('body > *')
            .not($('.gwp-block'))
            .not($('.gwp-block').parents())
            .filter(function() {
              return !this.hasAttribute('aria-hidden');
            });
          toHide.attr('aria-hidden', 'true').attr('data-gwp-aria-hidden', 'true');
          _theme.focusTrap($('.gwp-block'), function () {
            $('.gwp-trigger').focus();
          });
        }, 500);
      } else {
        // If expanded, close the modal and remove focus trap
        modalElement.attr('aria-hidden', 'true').stop().slideUp();
        $('[data-gwp-aria-hidden]')
          .removeAttr('aria-hidden')
          .removeAttr('data-gwp-aria-hidden');

        // Remove the focus trap event listener
        document.removeEventListener('focusin', _theme.focusTrap);

        // Return focus to the triggering element after closing
        targetElement.focus();
        console.log('Focus trap removed, event listener detached, and focus returned to trigger');
      }
    }

    function closeGWPModal(evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
      }

      $('[data-gwp-modal]').attr('aria-hidden', 'true').stop().slideUp();
      $('[data-gwp-trigger]').attr('aria-expanded', 'false');
    }

    function cartUpdateCallBack(resp) {
      closeGWPModal();
      lineItemChangeCallBack(resp);
      $('[data-gwp-modal] .btn-gwp').removeClass('loading');
      isAdding = false;
    }

    function run() {
      $('[data-gwp-trigger]').off('click', openGWPModal).on('click', openGWPModal);

      $('[data-gwp-modal] [data-gwp-modal-close]')
        .off('click', closeGWPModal)
        .on('click', closeGWPModal);

      $('[data-gwp-modal] .btn-gwp-apply')
        .off('click')
        .on('click', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();

          if (isAdding || !result.applicableOffer) return;
          const vid = $(this).data('vid');
          if (!vid) return;

          isAdding = true;
          $(this).addClass('loading');

          _theme.Helpers.addProductToCart(
            vid,
            1,
            {
              _type: result.applicableOffer.type,
              _discAmount: result.applicableOffer.discAmount,
            },
            cartUpdateCallBack
          );
        });

      $('[data-gwp-modal] .btn-gwp-remove')
        .off('click')
        .on('click', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();

          const lineItemKey = $(this).data('lineitem-key');
          if (isAdding || !lineItemKey) return;
          isAdding = true;
          $(this).addClass('loading');
          _theme.Helpers.changeLineItemQty(lineItemKey, 0, 1, cartUpdateCallBack);
        });

      $('[data-gwp-modal] .btn-gwp-update')
        .off('click')
        .on('click', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();

          const vid = $(this).data('vid');
          const lineItemKey = $(this).data('lineitem-key');
          if (isAdding || !lineItemKey || !vid) return;

          isAdding = true;
          $(this).addClass('loading');
          _theme.Helpers.changeLineItemQty(lineItemKey, 0, 1, function (cart) {
            _theme.Helpers.addProductToCart(
              vid,
              1,
              {
                _type: result.applicableOffer.type,
                _discAmount: result.applicableOffer.discAmount,
              },
              cartUpdateCallBack
            );
          });
        });
    }
  }

  function initAutoFreeGift() {
    if (!offerConfig || !offerConfig.gwp_auto) return;

    const gwp_enable = offerConfig.gwp.enable;
    const gwp_auto = offerConfig.gwp_auto;
    const enabled = gwp_auto.enable;
    const threshold = Number(gwp_auto.threshold);
    const discType = gwp_auto.discType;
    const discAmount = gwp_auto.discAmount;
    const vid = gwp_auto.vid;

    if (!offerConfig.gwp_auto.enable) {
      return;
    }
    if (offerConfig.gwp.enable && offerConfig.gwp_auto.enable) return; // Can't run both offer at a time
    if (!enabled || !threshold || !vid) return;

    init();

    function init(stopInitialization) {
      const giftLineItem = cartjson.items?.find((item) => item.properties?._proType === 'freeGift');

      if (giftLineItem) {
        if (cart_total_amt < threshold || !enabled) {
          _theme.Helpers.changeLineItemQty(giftLineItem.key, 0, 1, lineItemChangeCallBack);
        } else if (giftLineItem.quantity > 1) {
          const newQty = stopInitialization ? 0 : 1;
          _theme.Helpers.changeLineItemQty(giftLineItem.key, newQty, 1, lineItemChangeCallBack);
        }
      } else {
        if (!stopInitialization && !gwp_enable && enabled) {
          if (cart_total_amt >= threshold) {
            _theme.Helpers.addProductToCart(vid, 1, 'freeGift', lineItemChangeCallBack);
          }
        }
      }
    }

    // function init() {
    //   let cartTotal = cartjson.total_price;
    //   const autoGiftItem = cartjson.items.find(
    //     (item) => item.properties && item.properties._proType === 'freeGift'
    //   );
    //   if (autoGiftItem) cartTotal -= autoGiftItem.final_line_price;
    //   const cart_total_amt = cartTotal / 100;

    //   const $giftElem = jQuery(
    //     '#dropdown-cart .mini-products-list .item[data-free-gift-added="true"]'
    //   );
    //   if ($giftElem.length) {
    //     if (cart_total_amt < threshold || !enabled) {
    //       const viaId = vid ? true : false;
    //       const lineIndex = vid ? vid : $giftElem.attr('line-index');
    //       _theme.Helpers.changeLineItemQty(lineIndex, 0, viaId, lineItemChangeCallBack);
    //     } else {
    //       const qty = parseInt($giftElem.attr('data-quantity'));
    //       if (qty && qty > 1) {
    //         _theme.Helpers.changeLineItemQty(vid, 1, 1, lineItemChangeCallBack);
    //       }
    //     }
    //   } else if (!gwp_enable && enabled && cart_total_amt >= threshold) {
    //     _theme.Helpers.addProductToCart(vid, 1, 'freeGift', lineItemChangeCallBack);
    //   }
    // }
  }

  function init() {
    initMinicartShell();
  }

  return {
    init: init,
    prepareOnOpen: prepareOnOpen,
    prefetchMinicart: prefetchMinicart,
    loadMinicartContent: loadMinicartContent,
    lineItemChangeCallBack: lineItemChangeCallBack,
  };
})();

_theme.MiniCartQuickview = (function () {
  const isCartPage = document.querySelector('body.template-cart');
  const cache_product = {};
  let $activeElem = null;
  let selectedProduct = null;

  function init() {
    $('#dropdown-cart').removeClass('hidden');

    $('.sidecart-qv .sidecart-qv-close').click(function (a) {
      // $('*').not($('.sidecart-qv').find('*')).not('.sidecart-qv').not($('.sidecart-qv').parents()).attr('aria-hidden','false');
      (a.preventDefault(),
        $(this).closest('.sidecart-qv').removeAttr('data-id'),
        _theme.toggleSideCartQv());
      if ($activeElem) $activeElem.focus();
      $activeElem = null;
      if ($(this).hasClass('offer-sidecart-qv-close') || $('body').hasClass('quick-view-open')) {
        $('.wrapper-overlay').removeClass('active');
        $('body').removeClass('quick-view-open');
      }
    });

    $('.sidecart-qv').on('click', '.product_bottom .accordion-item .tab-title', function (a) {
      $(this).toggleClass('open').next('.tab-content').stop().slideToggle();
    });

    $('#dropdown-cart .cart-recommended-products [data-sidecartqv]')
      .off('click')
      .on('click touchend', function (e) {
        e.preventDefault();
        const $self = $(this);
        $activeElem = $self;
        const prod_url = $(this).data('url');
        const prod_id = $(this).data('id');
        if (!prod_url || !prod_id) return;
        handleQVClick(prod_url, prod_id);
      });

    $(document).on('click', '.sidecart-qv button.cta-atc', function (c) {
      const offerVid = parseInt(this.getAttribute('offer-var-id')) || parseInt($(this).attr('offer-var-id'));
      c.preventDefault();
      var d = $(this),
        a = getCurrentVariant(),
        b = d.closest('.sidecart-qv'),
        e = b.find('form'),
        c = d.closest('.sidecart-qv').find('.sidecart-qv-title span').text(),
        g = b.attr('data-id');
      if ($('.offer-quickview-footer .quantity__select').length) {
        if (offerVid) {
          var f = b
            .find('.sidecart-coll-cta .offer-quickview-footer select.quantity__select')
            .val();
        } else {
          var f = b.find('.offer-quickview-footer select.quantity__select').val();
        }
      } else {
        var f = e.find('.sidecart-qv-quantity-wrapper input[name="quantity"]').val();
      }
      if (a) {
        $(this).addClass('loading');
        _theme.toggleLoading(1);

        handleAddToCart(offerVid ? offerVid : a.id, f, function (a) {
          $('body').removeClass('quick-view-open');
          if (isCartPage && _theme.Cart && _theme.Cart.cartMapData) {
            _theme.Cart.cartMapData(a, function () {
              _theme.toggleLoading();
              _theme.toggleSideCartQv();
              _theme.toggleOverlay();
            });
          } else {
            itemAddedCallBack(a, d);
            const b = $('#dropdown-cart .cart-recommended-products button[data-id="' + g + '"]');
            b.addClass('added').find('span').text('Added');
            const addedMes = $('.added_error_message_text');
            addedMes.text(c + 'added to your cart successfully');
            if ($('.offer-quickview-footer .quantity__select').length) {
              $('.wrapper-overlay').removeClass('active');
              _theme.toggleSideCart(true, null, true);
            }
            _theme.focusTrap($('#dropdown-cart'), function () {
              _theme.toggleSideCart(false, null, false);
              if ($('.offer-quickview-footer .quantity__select').length) {
                $('.wrapper-overlay').removeClass('active');
              }
            });
            _theme.toggleSideCartQv();
            setTimeout(function () {
              b.removeClass('added').find('span').text('Quick view');
            }, 3e3);
            document.querySelector('.side-offers-close').click();
          }
        });
      }
    });

    $(document).on('click', '.sidecart-qv .sidecart-qv-quantity-wrapper button', function (d) {
      var b = $(this).parent().find('input[type="number"]'),
        d = $(this).parent().find('.sidecart-qv-qty-minus'),
        c = $(this).closest('.sidecart-qv-quantity').find('.sidecart-qv-current-qty'),
        a = Number(b.val());
      ($(this).hasClass('sidecart-qv-qty-minus') ? (a -= 1) : (a += 1),
        (a = a < 1 ? 1 : a),
        b.val(a),
        c.text(a));
      const $ariaElem = $(this).parent().find('[data-aria-live]');
      if (a > 1) {
        d.attr('disabled', false);
      } else {
        d.attr('disabled', true);
      }
      const msg =
        $(this).hasClass('sidecart-qv-qty-minus') && a < 1
          ? ' '
          : $(this).hasClass('sidecart-qv-qty-minus')
            ? 'item decreased by 1'
            : 'item increased by 1';
      $ariaElem.text('');
      setTimeout(function () {
        $ariaElem.text(msg);
      }, 250);
    });

    $(document).on('change', '.sidecart-qv .sidecart-qv-options input[type="radio"]', function (l) {
      const b = getCurrentVariant();

      // Check if product has applicable offer metafield
      const productOffer = selectedProduct.metafields?.custom?.applicable_offer;
      const variantOfferApplicable = b.metafields?.custom?.is_offer_applicable;

      if (
        productOffer &&
        productOffer !== '' &&
        productOffer !== null &&
        variantOfferApplicable === true &&
        b.available
      ) {
        $('.sidecart-qv .sidecart-qv-offer-label').removeClass('hidden');
      } else {
        $('.sidecart-qv .sidecart-qv-offer-label').addClass('hidden');
      }

      if (b) {
        const a = $('.sidecart-qv');
        a.find('form');
        const c = a.find('.sidecart-qv-cta .cta-atc'),
          f = a.find('.sidecart-qv-price.on-sale [data-text]'),
          d = a.find('.sidecart-qv-compare-price [data-text]'),
          e = a.find('.sidecart-qv-per-off');
        q = a.find('.sidecart-qv-current-qty');
        h = a.find('#sidecart-qv-qty-input');

        // a.find(".sidecart-qv-klarna");
        // var g = a.data("klarna-split"),
        // h = Number(a.data("klarna-min")),
        // i = b.price / 100 / g;
        q.text(1);
        h.val(1);
        if (
          (b.available
            ? c
                .removeClass('disabled')
                .removeAttr('disabled')
                .text(window.inventory_text.add_to_cart)
            : c
                .text(window.inventory_text.sold_out)
                .addClass('disabled')
                .attr('disabled', 'disabled'),
          f.html(Shopify.formatMoney(b.price, Shopify.money_format)),
          b.compare_at_price && b.compare_at_price > b.price)
        ) {
          d.removeClass('hidden').html(
            Shopify.formatMoney(b.compare_at_price, Shopify.money_format)
          );
          const j = Shopify.formatMoney(b.compare_at_price - b.price, Shopify.money_format);
          e.removeClass('hidden').html(
            'Save ' + j + '<span class="visually-hidden visually-hidden--inline">Discount</span>'
          );
        } else (d.addClass('hidden'), e.addClass('hidden'));

        const klarna = document.querySelector('.sidecart-qv-klarna klarna-placement');
        if (!klarna) return;
        klarna.setAttribute('data-purchase-amount', b.price);
        _theme.Helpers.refreshKlarna();
        // if (h < b.price) {
        //     var k = Shopify.formatMoney(i.toFixed(2), Shopify.money_format);
        //     a.find('[data-id="klarnaEmiAmount"]').text(k), a.find('[data-id="klarnaNonAvailabilityMessage"]').css("display", "none"), a.find('[data-id="klarnaAmountContainer"]').css("display", "inline")
        // } else a.find('[data-id="klarnaAmountContainer"]').css("display", "none"), a.find('[data-id="klarnaNonAvailabilityMessage"]').css("display", "inline")
      }
    });
  }

  function handleQVClick(prod_url, prod_id, variantId) {
    if (!prod_url || !prod_id) return;

    let product_url = prod_url;
    if (variantId) product_url += '?variant=' + variantId;
    product_url += (product_url.includes('?') ? '&' : '?') + 'view=sidecart-qv';
    _theme.toggleLoading(1);

    if (cache_product[prod_id]) {
      updateSideCartQv(cache_product[prod_id].html, prod_id);
    } else {
      $.get(product_url, function (res) {
        cache_product[prod_id] = { html: res };
        updateSideCartQv(res, prod_id);
      })
        .done(function (res) {
          _theme.toggleLoading();
        })
        .fail(function (a) {
          (console.log(a), _theme.toggleLoading());
          $self.removeClass('loading');
          alert('Something went wrong. Please try again later');
        });
    }
  }

  function updateSideCartQv(res, prod_id) {
    $('.sidecart-qv').attr('data-id', prod_id);

    // Check if the required elements exist in the response
    const $res = $(res);
    const $sidecartQvCta = $res.find('.sidecart-qv-cta');

    // Use the helper function to get the best available content
    const contentInfo = getBestAvailableContent($res);
    if (contentInfo) {
      $('.sidecart-qv .sidecart-qv-body').html(contentInfo.element.html());
    } else {
      $('.sidecart-qv .sidecart-qv-body').html(
        '<div class="error-message">Product information not available. <a href="' +
          window.location.origin +
          '/products/' +
          prod_id +
          '" target="_blank">View full product page</a></div>'
      );
    }
    if ($sidecartQvCta.length > 0) {
      $('.sidecart-coll-cta').html($sidecartQvCta.html());
      $('.sidecart-qv-cta').html($sidecartQvCta.html());
    } else {
      console.warn('Quickview: .sidecart-qv-cta not found in response for product:', prod_id);
    }

    setTimeout(function () {
      const imgSlickContainer = $('.sidecart-qv .sidecart-qv-images ul');
      if (imgSlickContainer.length > 0) {
        imgSlickContainer.on('init', function (b, c) {
          imgSlickContainer.closest('.sidecart-qv-images').removeClass('loading');
        });
        imgSlickContainer.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: !1,
          arrows: true,
        });
        $('.sidecart-qv-inner .sidecart-qv-images .slick-list .slick-track').attr(
          'role',
          'presentation'
        );
      }
    }, 500);

    _theme.qvVariants();

    // Only set first variant if swatch elements exist
    const availableSwatches = document.querySelectorAll(
      '.sidecart-qv .sidecart-qv-options .swatch-element.available'
    );
    if (availableSwatches.length > 0) {
      const firstInput = availableSwatches[0].querySelector('input');
      if (firstInput) {
        firstInput.checked = true;
      }
    }
    const c_v = getCurrentVariant();
    if (c_v) {
      const kl = document.querySelector('.sidecart-qv-klarna klarna-placement');
      kl && kl.setAttribute('data-purchase-amount', c_v.price);
    }
    _theme.toggleSideCartQv(1);
    _theme.Wishlist.init();
    _theme.toggleLoading();
    _theme.Helpers.refreshKlarna();

    try {
      selectedProduct = JSON.parse(
        $('.sidecart-qv').find('.sidecart-qv-body script[data-json]').text()
      );
    } catch (error) {
      console.log(error);
    }

    _theme.focusTrap(
      $('.sidecart-qv'),
      function () {
        _theme.toggleSideCartQv();
        if ($activeElem) $activeElem.focus();
        $activeElem = null;
      },
      'details'
    );
  }

  function getCurrentVariant() {
    try {
      const $parent = $('.sidecart-qv');
      const $form = $parent.find('form');
      const selectedVariantId = $form.find('.sidecart-qv-options input:checked').val();
      if (!selectedVariantId) return null;

      let current_v = null;
      const product = JSON.parse($parent.find('.sidecart-qv-body script[data-json]').text());
      if (!product.available) return null;

      const options = {};
      const optionSize = product.options.length;

      $form.find('.sidecart-qv-options .swatch').each(function () {
        const index = parseInt($(this).attr('data-option-index')) + 1;
        options['option' + index] = $(this).find('input:checked').val();
      });

      current_v =
        product.variants.length > 1
          ? product.variants.filter(function (v) {
              switch (optionSize) {
                case 1:
                  return options.option1 == v.option1;
                case 2:
                  return options.option1 == v.option1 && options.option2 == v.option2;
                case 3:
                  return (
                    options.option1 == v.option1 &&
                    options.option2 == v.option2 &&
                    options.option3 == v.option3
                  );
              }
            })[0]
          : product.variants[0];

      return current_v;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  function handleAddToCart(a, b, c) {
    _theme.Helpers.addProductToCart(a, b, null, function (a) {
      c && 'function' == typeof c && c(a);
    });
  }

  function itemAddedCallBack(resp, b) {
    _theme.MiniCart.lineItemChangeCallBack(resp);
    b.removeClass('loading');
    $('#dropdown-cart .error-box').hide();
    $('#dropdown-cart .item-added-note').removeClass('hidden');
    _theme.toggleLoading();
    _theme.toggleSideCartQv();
  }

  return {
    init: init,
    handleQVClick: handleQVClick,
  };
})();

_theme.pushBackButton = (function () {
  function init() {
    const pushBackButton = $('.backButtonPdp');
    pushBackButton.off('click').on('click', function (e) {
      e.preventDefault();
      _theme.Helpers.goToPreviousPage();
    });
  }
  return { init: init };
})();

_theme.ScrollEvent = (function () {
  const headerOff = $('header.site-header').offset().top;
  let prevScroll = 0;
  function init() {
    $(window).scroll(function () {
      const scrollTop = $(this).scrollTop();
      if (scrollTop > 100) $('[data-backtotop]').addClass('active');
      else $('[data-backtotop]').removeClass('active');

      if ($('html').hasClass('translate-overlay')) {
        if ($('[data-backtotop]').hasClass('active')) {
          $('[data-backtotop]').removeClass('active');
        }
      }

      if (scrollTop > headerOff) {
        $('body').addClass('header-fixed');
        if (prevScroll > scrollTop) {
          $('body').addClass('scroll-up');
        } else {
          $('body').removeClass('scroll-up');
        }
      } else {
        $('body').removeClass('header-fixed scroll-up');
      }
      prevScroll = scrollTop;
    });
    //Click event to scroll to top
    $('[data-backtotop]').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 800, function () {
        const announcementLink = $('.announcementMain .announcement-bar__link').is(':visible');
        if (announcementLink) {
          $('.announcementMain .announcement-bar__link').attr('tabindex', '-1').focus();
        } else {
          $('header .find-a-store a').attr('tabindex', '-1').focus();
        }
      });
      return false;
    });
  }
  return { init: init };
})();

_theme.Newsletter = (function () {
  function init() {
    const formPosted = _theme.Helpers.getParamFromURL('customer_posted');
    const alreadySubscribed = _theme.Helpers.getParamFromURL('form_type');
    if (formPosted && window.gtag) {
      gtag('event', 'subscribe_newsletter', { method: 'Footer' });
      setTimeout(() => {
        _theme.track.trackData({ event: 'newsletterSubscribed' });
      }, 500);
    }
    if (!formPosted && !(alreadySubscribed == 'customer')) return;

    const popup = !formPosted
      ? $('.newsletter-success-modal.already-subscribed')
      : $('.newsletter-success-modal.not-yet-subscribed');
    const close = popup.find('.close');
    const overlay = popup.find('.modal-overlay');
    popup.show();
    setTimeout(function () {
      $('.newsletter-success-modal').focus();
    });
    _theme.Helpers.setCookie('emailSubcribeModal', 'closed', 1);
    // $.cookie('emailSubcribeModal', 'closed', {
    //     expires: 1,
    //     path: '/'
    // });
    close.off('click').on('click', function () {
      popup.fadeOut();
      $('.skip-to-maincontent.show').focus();
    });
    overlay.off('click').on('click', function () {
      popup.fadeOut();
      $('.skip-to-maincontent.show').focus();
    });
    const newURL = !formPosted
      ? _theme.Helpers.deleteParamFromURL('form_type')
      : _theme.Helpers.deleteParamFromURL('customer_posted');
    history.replaceState('', '', newURL);
  }

  return { init: init };
})();

_theme.initTooltip = function () {
  const qtBtns = document.querySelectorAll('.toolTipToggle');
  qtBtns.forEach((btn) => {
    btn.removeEventListener('focusin', run);
    btn.addEventListener('focusin', run);
  });

  function run(evt) {
    const target = evt.target;
    target.classList.add('show-tooltip');
    setTimeout(() => {
      target.classList.remove('show-tooltip');
    }, 2500);
  }
};

_theme.initSlickBtnEvent = function () {
  const slickBtns = document.querySelectorAll('.slick-initialized .slick-arrow');
  slickBtns.forEach((btn) => {
    btn.removeEventListener('focusin', run);
    btn.addEventListener('focusin', run);
  });

  function run(evt) {
    const target = evt.target;
    target.classList.add('show-tooltip');
    setTimeout(() => {
      target.classList.remove('show-tooltip');
    }, 2500);
  }
};

_theme.executeDefferedStylesheet = function () {
  const styles = document.querySelectorAll('link[data-defer]');
  styles.forEach((style) => {
    style.media = 'all';
  });
};

window.Shopify = window.Shopify || {};
Shopify.onError = function (t, r) {
  if ($('button.click-processing').length)
    $('button.click-processing').removeAttr('disabled').removeClass('click-processing');
  const e = eval('(' + t.responseText + ')');
  e.message
    ? alert(e.message + '(' + e.status + '): ' + e.description)
    : alert('Error : ' + Shopify.fullMessagesFromErrors(e).join('; ') + '.');
};

document.addEventListener('lazybeforeunveil', function (e) {
  const target = e.target;
  let bgImgUrl = null;
  if (_theme.isMobile) bgImgUrl = target.getAttribute('data-bg-mob');
  else bgImgUrl = target.getAttribute('data-bg-desk');
  if (bgImgUrl) target.style.backgroundImage = 'url(' + bgImgUrl + ')';
});

$(function () {

  _theme.executeDefferedStylesheet();
  _theme.loadSection();
  _theme.removeElements();
  _theme.initHeaderEvetns();
  _theme.initSlideShow();
  _theme.initTrackOrderPage();
  _theme.initHorizontalScroll();
  _theme.redemptionPopup();
  _theme.Wishlist.init();
  _theme.MiniCart.init();
  _theme.MiniCartQuickview.init();
  _theme.ProductGridQuickView.init();
  _theme.ScrollEvent.init();
  _theme.Newsletter.init();
  // _theme.initGTM();
  _theme.updateDOMOnResize();
  // _theme.setMinicartHeight();
  _theme.pushBackButton.init();

  setTimeout(_theme.initLazyloadData, 1000);

  $('.modal.halo_modal-custom.popup-shipping.fd.halo_modal-custom .close-modal').click(function () {
    $('body').removeClass('modal-open');
    $('.popup-shipping').css('display', 'none');
    $('.popup-shipping').removeClass('show');
    // window.location.hash = '';
    setTimeout(function () {
      if (_theme.isMobile) $('#mob-shipping-policy-model-trigger').focus();
      else $('#desk-shipping-policy-model-trigger').focus();
    }, 500);
  });

  setTimeout(function () {
    if (window.innerWidth > 767) {
      $('[data-griditem] [data-toggle-menu-mb]').attr({
        'aria-hidden': true,
        tabindex: -1,
      });
    } else {
      $('[data-griditem] [data-toggle-menu-mb]').attr({
        'aria-hidden': false,
        tabindex: 0,
      });
    }
  }, 1000);

  _theme.Wishlist.init();

  const trustpilot = document.querySelector('trustpilot-summary');
  if (trustpilot) trustpilot.updateGlobalSrOnlyText();
});

$(window).on('load', function () {
  _theme.loadAppScript();
});

$(document).ready(function (evt) {
  setTimeout(function () {
    $('.product-thumb-slider .slick-list').attr('role', 'presentation');
    $('.product-thumb-slider .slick-list .slick-track').attr('role', 'presentation');
  }, 1000);

  $(document).on('keyup', '#dropdown-cart .mini-products-list .quantity-box .button', function (e) {
    if (e.which === 13 || e.which === 32) {
      $(e.target).trigger('click');
    }
  });

  // Issue#9 : IDs of active elements must be unique (AXE)
  $(window).on('load', function () {
    if ($('.checkurl').length) {
      $('.checkurl').removeAttr('id');
    }
    // Issue#12 : Elements must only use allowed ARIA attributes
    if ($('.product__info-container .product-form__input input').length) {
      $('.product__info-container .product-form__input input').removeAttr('aria-labelledby');
    }

    // Issue#12 : Elements must only use allowed ARIA attributes (AXE)
    if ($('fieldset.product-form__input input').length) {
      $('fieldset.product-form__input input').removeAttr('aria-selected');
    }

    // if($('.product .product-thumb-slider li').length) {
    //   $('.product .product-thumb-slider li button').attr('tabindex','-1');
    // }

    if ($('.cm-mega-menu-filter-content').length) {
      $('.cm-mega-menu-filter-content').removeAttr('id');
    }
  });

  // Issue#20 :
  $(document).on('keyup', '.footer-pane-item.support-chat .content', function (e) {
    if (e.which === 13 || e.which === 32) {
      $(e.target).trigger('click');
    }
  });

  $(document).on('keyup', '[data-backtotop]', function (e) {
    if (e.which === 13 || e.which === 32) {
      $(e.target).trigger('click');
      $('.skip-to-content-link').focus();
    }
  });

  if ($('.dealerlocator').length) {
    $('.dealerlocator').attr('Title', 'Perfumania store location on google map');
  }

  if (window.innerWidth < 769) {
    _theme.initSlickSlider($('.bundle-coll-wrap.bundle1Slide'), {
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2,
          },
        },
      ],
    });
  }

  _theme.initSlickSlider($('.bundle2Inner .bundle2Slide'), {
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1028,
        settings: {
          arrows: true,
          slidesToShow: 3.25,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.announcement-popup-trigger[data-popup-name]');
    if (!trigger) return;

    if (typeof _ltk === 'undefined') {
      window.dispatchEvent(new Event('scroll'));
    }

    const checkAndOpen = () => {
      if (typeof _ltk !== 'undefined' && _ltk.Popup) {
        try {
          _ltk.Popup.openManualByName('Perfumania - 5P - Manual Email - SMS');
        } catch (err) {
          console.error('[Announcement Popup] Failed to open popup:', err);
        }
      } else {
        setTimeout(checkAndOpen, 100);
      }
    };
    checkAndOpen();
  });

  $(document).on('click', '.announcementCloseIcon', function (evt) {
    evt.preventDefault();

    const $announcementSection = $('#shopify-section-announcement-bar');
    $announcementSection.find('slideshow-container').each(function () {
      if (this.swiper?.autoplay) {
        this.swiper.autoplay.stop();
      }
    });
    $announcementSection.hide().attr('hidden', true);

    let showAlert = false;
    if (evt.originalEvent && evt.originalEvent.pointerId === -1) showAlert = true;
    if (evt.buttons && evt.buttons === 1) showAlert = true;
    if (showAlert) _theme.Helpers.showNotification('Announcementbar is hidden now');
  });

  _theme.initSlickBtnEvent();
  _theme.initTooltip();
  //  =============================
  function initDeviceVaries() {
    const htmlSelector = document.querySelector('html');
    Array.from(htmlSelector.classList).map(function (cls) {
      if (cls.indexOf('device--') > -1) htmlSelector.classList.remove(cls);
    });

    const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    if (browserZoomLevel > 200) {
      htmlSelector.classList.add('mode--zoom');
    } else {
      htmlSelector.classList.remove('mode--zoom');
    }
    if (screen.availWidth > 767) htmlSelector.classList.add('device--ipadandup');
    else htmlSelector.classList.add('device--mobile');

    const oSClass = 'device--' + _theme.getOS();
    const deviceClass = 'device--' + _theme.getOS() + '-v-' + _theme.iPhoneVersion();
    htmlSelector.classList.add(oSClass);
    htmlSelector.classList.add(deviceClass);
  }

  initDeviceVaries();
  window.addEventListener('resize', debounce(initDeviceVaries, 300));

  window.onkeydown = function (event) {
    if (event.keyCode == 27) {
      if (document.querySelector('.ltkpopup-close'))
        document.querySelector('.ltkpopup-close').click();
    }
  };
});

if (window.innerWidth < 768) {
  const updateNotchRelatedUI = function () {
    const screenHeight = screen.availHeight;
    const availableHeight = window.innerHeight;
    const diff = screenHeight - availableHeight;
    if (diff === 0) document.documentElement.classList.remove('notch-xs', 'notch-md');
    else if (diff > 100) {
      document.documentElement.classList.remove('notch-xs');
      document.documentElement.classList.add('notch-md');
    } else {
      document.documentElement.classList.remove('notch-md');
      document.documentElement.classList.add('notch-xs');
    }
  };
  updateNotchRelatedUI();
  window.onresize = debounce(updateNotchRelatedUI, 300);
}

document.addEventListener('readystatechange', (event) => {
  // When HTML/DOM elements are ready:
  if (event.target.readyState === 'interactive') {
    //does same as:  ..addEventListener("DOMContentLoaded"..
  }

  // When window loaded ( external resources are loaded too- `css`,`src`, etc...)
  if (event.target.readyState === 'complete') {
    setTimeout(() => {
      $('.grecaptcha-badge').attr('role', 'complementary');
    }, 4000);
  }
});
$(document).ready(function () {
  // Pre-create the drawer live region on load so it exists in DOM before updates,
  // preventing screen readers from ignoring the text insertions.
  const dropdownCart = document.getElementById('dropdown-cart');
  if (dropdownCart && !document.getElementById('dropdown-cart-sr-only')) {
    const liveRegion = document.createElement('span');
    liveRegion.id = 'dropdown-cart-sr-only';
    liveRegion.className = 'visually-hidden';
    liveRegion.setAttribute('role', 'status');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-hidden', 'true');
    dropdownCart.appendChild(liveRegion);
  }

  function initMinicartQuantityValidation() {
    function setNativeValue(input, val) {
      const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
      if (descriptor && descriptor.set) {
        descriptor.set.call(input, val);
      } else {
        input.value = val;
      }
    }

    function validateInput(input, value) {
      const max = parseInt(input.getAttribute('max')) || 9;
      const min = parseInt(input.getAttribute('min')) || 1;
      const errorElement = document.getElementById(input.getAttribute('aria-describedby'));
      const strVal = String(value);

      // Clear any existing validation timer for this input
      if (input._validationTimeout) {
        clearTimeout(input._validationTimeout);
        input._validationTimeout = null;
      }

      if (strVal === '' || strVal === '0') {
        input.removeAttribute('aria-invalid');
        if (errorElement) {
          errorElement.textContent = '';
        }
        return true;
      }

      // Check for non-digit characters, empty input, or browser-reported invalid state
      const isBad =
        (input.validity && input.validity.badInput) ||
        /\D/.test(strVal) ||
        value === '' ||
        isNaN(parseInt(strVal));

      if (isBad) {
        input.setAttribute('aria-invalid', 'true');
        if (errorElement) {
          errorElement.textContent = 'Quantity must be a number';
          errorElement.style.color = '#f1152f';
        }
        // Auto-revert to the last valid value after 3 seconds
        input._validationTimeout = setTimeout(function () {
          const lastValid = input.getAttribute('aria-valuenow') || '1';
          setNativeValue(input, lastValid);
          validateInput(input, lastValid);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }, 3000);
        return false;
      }

      const parsedVal = parseInt(strVal);
      if (parsedVal > max || parsedVal < min) {
        input.setAttribute('aria-invalid', 'true');
        if (errorElement) {
          errorElement.textContent = 'Quantity must be between ' + min + ' and ' + max;
          errorElement.style.color = '#f1152f';
        }
        // Auto-revert to the last valid value after 3 seconds
        input._validationTimeout = setTimeout(function () {
          const lastValid = input.getAttribute('aria-valuenow') || '1';
          setNativeValue(input, lastValid);
          validateInput(input, lastValid);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }, 3000);
        return false;
      }

      input.removeAttribute('aria-invalid');
      if (errorElement) {
        errorElement.textContent = '';
      }
      input.setAttribute('aria-valuenow', strVal);
      return true;
    }

    _theme.validateMinicartInput = validateInput;
    _theme.setMinicartNativeValue = setNativeValue;

    // Delegated keydown event listener on document (capture phase)
    document.addEventListener(
      'keydown',
      function (e) {
        const input = e.target;
        if (!input.classList || !input.classList.contains('cart-quantity-input')) {
          return;
        }

        const max = parseInt(input.getAttribute('max')) || 9;
        const min = parseInt(input.getAttribute('min')) || 1;
        const val = parseInt(input.value) || 0;
        const errorElement = document.getElementById(input.getAttribute('aria-describedby'));

        if (e.key === 'Enter') {
          e.preventDefault();
          input.blur();
          return;
        }

        if (e.key === 'ArrowUp') {
          if (val >= max) {
            e.preventDefault();
            input.setAttribute('aria-invalid', 'true');
            if (errorElement) {
              errorElement.textContent = 'Quantity must be between ' + min + ' and ' + max;
              errorElement.style.color = '#f1152f';
            }
            if (input._validationTimeout) clearTimeout(input._validationTimeout);
            input._validationTimeout = setTimeout(function () {
              input.removeAttribute('aria-invalid');
              if (errorElement) errorElement.textContent = '';
            }, 3000);
          }
          return;
        }
        if (e.key === 'ArrowDown') {
          if (val <= min) {
            e.preventDefault();
            input.setAttribute('aria-invalid', 'true');
            if (errorElement) {
              errorElement.textContent = 'Quantity must be between ' + min + ' and ' + max;
              errorElement.style.color = '#f1152f';
            }
            if (input._validationTimeout) clearTimeout(input._validationTimeout);
            input._validationTimeout = setTimeout(function () {
              input.removeAttribute('aria-invalid');
              if (errorElement) errorElement.textContent = '';
            }, 3000);
          }
          return;
        }

        const allowedKeys = [
          'Backspace',
          'Delete',
          'Tab',
          'Escape',
          'Enter',
          'ArrowLeft',
          'ArrowRight',
        ];
        if (allowedKeys.indexOf(e.key) !== -1 || e.ctrlKey || e.metaKey) {
          return;
        }

        if (e.key && e.key.length === 1 && !/[0-9]/.test(e.key)) {
          e.preventDefault();
          input.setAttribute('aria-invalid', 'true');
          if (errorElement) {
            errorElement.textContent = 'Quantity must be a number';
            errorElement.style.color = '#f1152f';
          }
          if (input._validationTimeout) clearTimeout(input._validationTimeout);
          input._validationTimeout = setTimeout(function () {
            input.removeAttribute('aria-invalid');
            if (errorElement) errorElement.textContent = '';
          }, 3000);
        }
      },
      true
    );

    // Delegated input/change event listeners
    function handleQuantityInput(e) {
      if (e.target.classList && e.target.classList.contains('cart-quantity-input')) {
        validateInput(e.target, e.target.value);
      }
    }
    document.addEventListener('input', handleQuantityInput);
    document.addEventListener('change', handleQuantityInput);

    // Delegated focusout event listener to auto-correct value on blur
    document.addEventListener('focusout', function (e) {
      const input = e.target;
      if (!input.classList || !input.classList.contains('cart-quantity-input')) {
        return;
      }

      if (input._validationTimeout) {
        clearTimeout(input._validationTimeout);
        input._validationTimeout = null;
      }

      const max = parseInt(input.getAttribute('max')) || 9;
      const min = parseInt(input.getAttribute('min')) || 1;
      const valStr = input.value;
      const parsed = parseInt(valStr);

      if (valStr === '0' || valStr === '' || parsed === 0) {
        const $parent = $(input).closest('[line-index]');
        const $removeBtn = $parent.find('.btn-remove');
        if ($removeBtn.length) {
          $removeBtn.trigger('click');
          return;
        }
      }

      const targetVal =
        valStr === '' || isNaN(parsed) ? 1 : parsed > max ? max : parsed < min ? min : null;
      if (targetVal !== null) {
        setNativeValue(input, targetVal);
        validateInput(input, targetVal);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Initialize aria-valuenow for existing inputs
    document.querySelectorAll('.cart-quantity-input').forEach(function (input) {
      if (!input.getAttribute('aria-valuenow')) {
        input.setAttribute('aria-valuenow', input.value);
      }
    });
  }

  initMinicartQuantityValidation();

  const getLiveRegion = (clickedElement) => {
    // If the cart drawer modal is open/active, we MUST use a live region inside it,
    // otherwise the aria-modal="true" attribute will block screen readers from announcing it.
    const isCartOpen = $('html').hasClass('cart-show');
    if (isCartOpen) {
      const liveRegion = document.getElementById('dropdown-cart-sr-only');
      if (liveRegion) return liveRegion;
    }

    return (
      document.getElementById('minicart-sr-only') ||
      clickedElement
        ?.closest('.grid-item, .product-item, .cart-recommendation-wrap')
        ?.querySelector('[data-aria-live]')
    );
  };

  const announceCartAddInProgress = (clickedElement) => {
    const liveRegion = getLiveRegion(clickedElement);

    if (!liveRegion) return;

    liveRegion.removeAttribute('aria-hidden');
    liveRegion.textContent = '';
    liveRegion.textContent = 'Please wait, adding product to cart';

    if (liveRegion._clearTimeout) clearTimeout(liveRegion._clearTimeout);
    liveRegion._clearTimeout = setTimeout(function () {
      if (liveRegion.textContent === 'Please wait, adding product to cart') {
        liveRegion.textContent = '';
        liveRegion.setAttribute('aria-hidden', 'true');
      }
    }, 2000);
  };

  const announceCartAddSuccess = (clickedElement) => {
    const productName = (clickedElement?.getAttribute('data-product-title') || '').trim();
    const message = productName ? `${productName} added to cart` : 'Item added to cart';
    const liveRegion = getLiveRegion(clickedElement);

    if (!liveRegion) return;

    liveRegion.removeAttribute('aria-hidden');
    liveRegion.textContent = '';
    liveRegion.textContent = message;

    if (liveRegion._clearTimeout) clearTimeout(liveRegion._clearTimeout);
    liveRegion._clearTimeout = setTimeout(function () {
      if (liveRegion.textContent === message) {
        liveRegion.textContent = '';
        liveRegion.setAttribute('aria-hidden', 'true');
      }
    }, 2000);
  };

  $('body').on('click', '.cart-recom-atc', function () {
    const clickedBtn = this;
    const varId = $(this).attr('data-var-id');
    const vid = parseInt(varId);
    const clickTime = Date.now();
    announceCartAddInProgress(clickedBtn);

    // Do Not Remove Code - Add Properties for GWP Discount
    const properties = {};
    const bundleVarIdElement = $(this).closest('.grid-item').find('[data-bundleVarId]');
    if (bundleVarIdElement.length > 0) {
      properties['_bundleVarId'] = bundleVarIdElement.val() || null;
    }
    // Do Not Remove Code - Add Properties for GWP Discount

    _theme.Helpers.addProductToCart(vid, 1, properties, function (resp) {
      const elapsed = Date.now() - clickTime;
      const progressDelay = Math.max(0, 1500 - elapsed);

      setTimeout(function () {
        announceCartAddSuccess(clickedBtn);

        const isCartPage = document.querySelector('body.template-cart');
        if (isCartPage && _theme.Cart && _theme.Cart.cartMapData) {
          _theme.Cart.cartMapData(resp, function () {
            _theme.toggleLoading();
            _theme.toggleSideCartQv();
          });
        } else {
          _theme.MiniCart.lineItemChangeCallBack(resp, function () {
            _theme.toggleSideCart(true, null, true);
          });
        }
      }, progressDelay);
    });
  });
  const viewportHeight = window.innerHeight;
  if (_theme.isMobile) {
    window.addEventListener('resize', function () {
      const newViewportHeight = window.innerHeight;
      const sidecartQV = document.querySelector('.sidecart-qv');
      if (sidecartQV) {
        sidecartQV.style.height = newViewportHeight + 'px';
      }
    });
  }
  document
    .querySelectorAll('h1, h2, h3, h4, h5, h6')
    .forEach((h) => !h.textContent.trim() && h.remove());
});

// Function to check if sidecart-qv template exists for a product
function checkSidecartQvTemplate(productUrl) {
  return new Promise((resolve) => {
    const testUrl = productUrl + (productUrl.includes('?') ? '&' : '?') + 'view=sidecart-qv';

    $.get(testUrl, function (res) {
      const $res = $(res);
      const hasTemplate =
        $res.find('.pdp-sidecart-qv-body').length > 0 ||
        $res.find('.sidecart-qv-body').length > 0 ||
        $res.find('.product-wrapper').length > 0;
      resolve(hasTemplate);
    }).fail(function () {
      resolve(false);
    });
  });
}

// Function to get the best available content from response
function getBestAvailableContent($res) {
  // Priority order for content selection
  const selectors = [
    '.pdp-sidecart-qv-body',
    '.sidecart-qv-body',
    '.product-wrapper',
    '.product-single',
    '.product__info-container',
  ];

  for (const selector of selectors) {
    const $element = $res.find(selector);
    if ($element.length > 0) {
      return { element: $element, type: selector };
    }
  }

  return null;
}

// Add CSS for error message styling
function addQuickviewErrorStyles() {
  if (!document.getElementById('quickview-error-styles')) {
    const style = document.createElement('style');
    style.id = 'quickview-error-styles';
    style.textContent = `
      .sidecart-qv .error-message {
        text-align: center;
        padding: 40px 20px;
        color: #d32f2f;
        background: rgba(211, 47, 47, 0.1);
        border-radius: 8px;
        border: 2px solid #d32f2f;
        margin: 20px;
      }
      .sidecart-qv .error-message a {
        color: #1976d2;
        text-decoration: underline;
        font-weight: 600;
      }
      .sidecart-qv .error-message a:hover {
        color: #1565c0;
      }
    `;
    document.head.appendChild(style);
  }
}

// Initialize error styles
addQuickviewErrorStyles();

// Listen for global Add-to-Cart events to trigger wishlist removal
document.addEventListener('cart:item_added', function (event) {
  try {
    const handle = event.detail.handle;
    if (handle && _theme.Wishlist && _theme.Wishlist.removeFromWishlistSilently) {
      _theme.Wishlist.removeFromWishlistSilently(handle);
    }
  } catch (e) {
    // Fallback block — never break the site on wishlist logic errors
  }
});
